'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var i18n = require('@nuklear9/i18n');
var classNames = require('classnames');
var react$1 = require('@headlessui/react');
var formik = require('formik');
var lodash = require('lodash');
var useQueryParams = require('use-query-params');
var reactHelmet = require('react-helmet');
var Masonry = require('react-masonry-css');
var reactInstantsearchDom = require('react-instantsearch-dom');
require('swiper/css');
require('swiper/css/navigation');
require('swiper/css/pagination');
var modules = require('swiper/modules');
var react = require('swiper/react');
var BodyClassName = require('react-body-classname');
var DatePicker = require('react-datepicker');
var getVideoId = require('get-video-id');
var ModalVideo = require('react-modal-video');
var algoliasearch = require('algoliasearch/lite');
var qs = require('qs');
var reactFrameworkBridge = require('@amazeelabs/react-framework-bridge');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var Masonry__default = /*#__PURE__*/_interopDefaultLegacy(Masonry);
var BodyClassName__default = /*#__PURE__*/_interopDefaultLegacy(BodyClassName);
var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker);
var getVideoId__default = /*#__PURE__*/_interopDefaultLegacy(getVideoId);
var ModalVideo__default = /*#__PURE__*/_interopDefaultLegacy(ModalVideo);
var algoliasearch__default = /*#__PURE__*/_interopDefaultLegacy(algoliasearch);
var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);

const Calendar = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      }
    )
  );
};

const Clock = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      }
    )
  );
};

const Close = ({ className, strokeWidth = 2 }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth,
        d: "M6 18L18 6M6 6l12 12"
      }
    )
  );
};

const DocumentPlaceholder = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 54.253 73.982",
      fill: "currentColor"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        className: "a",
        d: "M70.76,21.934,54.32,5.493A1.623,1.623,0,0,0,53.169,5H21.932A4.947,4.947,0,0,0,17,9.932V74.05a4.947,4.947,0,0,0,4.932,4.932H66.321a4.947,4.947,0,0,0,4.932-4.932V23.084A1.623,1.623,0,0,0,70.76,21.934ZM54.813,10.59,65.663,21.44H56.457A1.649,1.649,0,0,1,54.813,19.8Zm11.508,65.1H21.932a1.649,1.649,0,0,1-1.644-1.644V9.932a1.649,1.649,0,0,1,1.644-1.644H51.525V19.8a4.947,4.947,0,0,0,4.932,4.932H67.965V74.05A1.649,1.649,0,0,1,66.321,75.694ZM26.207,34.428a1.631,1.631,0,0,0,2.137-.822l2.137-4.768h7.563l2.137,4.768a1.718,1.718,0,0,0,1.48.986,1.934,1.934,0,0,0,.658-.164,1.565,1.565,0,0,0,.822-2.137l-6.576-14.8a1.624,1.624,0,0,0-1.48-.986H33.44a1.624,1.624,0,0,0-1.48.986l-6.576,14.8A1.565,1.565,0,0,0,26.207,34.428Zm8.056-14.057,2.3,5.179h-4.6ZM63.033,32.949a1.649,1.649,0,0,1-1.644,1.644H49.881a1.644,1.644,0,0,1,0-3.288H61.389A1.649,1.649,0,0,1,63.033,32.949Zm0,11.508A1.649,1.649,0,0,1,61.389,46.1H26.864a1.644,1.644,0,0,1,0-3.288H61.389A1.649,1.649,0,0,1,63.033,44.457Zm0,11.508a1.649,1.649,0,0,1-1.644,1.644H26.864a1.644,1.644,0,0,1,0-3.288H61.389A1.649,1.649,0,0,1,63.033,55.965Zm0,11.508a1.649,1.649,0,0,1-1.644,1.644H26.864a1.644,1.644,0,0,1,0-3.288H61.389A1.649,1.649,0,0,1,63.033,67.473Z",
        transform: "translate(-17 -5)"
      }
    )
  );
};

const Download = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      }
    )
  );
};

const Envelope = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "158.2",
      height: "158.2",
      viewBox: "0 0 158.2 158.2"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M38.186,153.414,0,182.384v81.828H158.2V182.384l-38.186-28.97H38.186Z",
        transform: "translate(0 -106.011)",
        fill: "#1f4f59"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M397.241,19.093V8.183a8.183,8.183,0,0,1,16.366,0v10.91Z",
        transform: "translate(-274.5)",
        fill: "#bebebe"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M202.041,125.469V8.183A8.182,8.182,0,0,1,210.224,0H122.941a8.182,8.182,0,0,0-8.183,8.183V125.469Z",
        transform: "translate(-79.3)",
        fill: "#e6e6e6"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M0,247.172l54.552,40.914h49.1L158.2,247.172V329H0Z",
        transform: "translate(0 -170.8)",
        fill: "#a7af40"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M0,382.474,74.155,326.22a8.183,8.183,0,0,1,9.89,0L158.2,382.474Z",
        transform: "translate(0 -224.274)",
        fill: "#858d20"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M167.724,52.966h54.552V96.607H167.724Z",
        transform: "translate(-115.9 -36.6)",
        fill: "#ed9d25"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement("g", { transform: "translate(49.097 70.917)" }, /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M158.9,264.828h51.824v5.455H158.9Z",
        transform: "translate(-158.897 -253.917)",
        fill: "#999"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M220.69,229.517H261.6v5.455H220.69Z",
        transform: "translate(-201.597 -229.517)",
        fill: "#999"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M185.379,229.517h5.455v5.455h-5.455Z",
        transform: "translate(-177.196 -229.517)",
        fill: "#999"
      }
    )),
    /* @__PURE__ */ React__default["default"].createElement("g", { transform: "translate(61.181 26.478)" }, /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M477.444,36.595h-.513l.057-.065c2.386-2.734,3.306-5.081,2.522-6.438-.53-.919-1.794-1.4-3.656-1.4-3.261,0-8.059,1.441-13.171,3.956,1,.5,1.983,1.038,2.934,1.587,1.236.714,2.47,1.485,3.665,2.293l.107.072H468.7l-.01-.007c-1.053-.7-2.152-1.38-3.267-2.024-1.014-.585-2.08-1.159-3.17-1.706-1.089.546-2.155,1.12-3.17,1.706-1.115.643-2.214,1.324-3.267,2.024l-.01.007h-.688l.107-.072c1.195-.807,2.428-1.579,3.665-2.293.951-.549,1.937-1.083,2.934-1.587-5.112-2.514-9.91-3.956-13.172-3.956-1.861,0-3.125.486-3.656,1.4-.783,1.357.136,3.7,2.523,6.438l.057.065h-.513l-.012-.014c-2.4-2.815-3.252-5.188-2.389-6.683,1.613-2.794,9.009-1.731,17.591,2.528,8.581-4.258,15.977-5.322,17.59-2.528.863,1.495.014,3.868-2.389,6.683Z",
        transform: "translate(-444.335 -28.347)",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: "1"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M448.65,79.8c-2.02,0-3.4-.538-3.985-1.554-.858-1.486-.024-3.843,2.348-6.636l.012-.014h.513l-.057.066c-2.355,2.713-3.26,5.043-2.481,6.391,1.494,2.589,8.566,1.514,16.831-2.551-1.018-.515-2.006-1.049-2.937-1.587-1.215-.7-2.424-1.457-3.6-2.246l-.107-.072h.689l.01.007c1.029.682,2.105,1.347,3.2,1.977,1.03.595,2.1,1.169,3.17,1.708,1.074-.539,2.14-1.114,3.17-1.708,1.092-.63,2.167-1.3,3.2-1.977l.01-.007h.689l-.107.072c-1.172.789-2.382,1.545-3.6,2.246-.93.537-1.918,1.07-2.937,1.587,8.264,4.065,15.336,5.139,16.831,2.551.779-1.348-.126-3.677-2.481-6.391l-.057-.066h.513l.012.014c2.372,2.793,3.206,5.149,2.348,6.636-.587,1.017-1.966,1.554-3.988,1.554-3.415,0-8.372-1.488-13.6-4.084-5.232,2.6-10.189,4.084-13.6,4.084Z",
        transform: "translate(-444.336 -56.379)",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: "1"
      }
    ))
  );
};

const Info = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      }
    )
  );
};

const MapMarker = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      }
    )
  );
};

const Events = ({
  startDate,
  endDate,
  Location,
  className,
  AdditionalInformation
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]("bg-[#f7f7f0] px-6 py-8", className) }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-7" }, t("ui.contentEventLabel")), /* @__PURE__ */ React__default["default"].createElement("ul", { className: "md:text-xl" }, /* @__PURE__ */ React__default["default"].createElement("li", { className: "flex font-medium" }, /* @__PURE__ */ React__default["default"].createElement(Clock, { className: "h-6 w-6 inline-block mr-3" }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1" }, startDate, endDate ? /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("span", { className: "mx-3 font-bold" }, "\u2212"), " ", endDate) : null)), /* @__PURE__ */ React__default["default"].createElement("li", { className: "flex mt-3" }, /* @__PURE__ */ React__default["default"].createElement(MapMarker, { className: "h-6 w-6 inline-block mr-3" }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1" }, /* @__PURE__ */ React__default["default"].createElement(
    Location,
    {
      classNames: {
        a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
      }
    }
  ))), AdditionalInformation ? /* @__PURE__ */ React__default["default"].createElement("li", { className: "flex mt-3" }, /* @__PURE__ */ React__default["default"].createElement(Info, { className: "h-6 w-6 inline-block mr-3" }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1" }, /* @__PURE__ */ React__default["default"].createElement(
    AdditionalInformation,
    {
      classNames: {
        a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
      }
    }
  ))) : null));
};

const Facebook = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 26.197 26.197",
      width: "20",
      height: "20",
      className
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M24.757 0H1.441A1.44 1.44 0 0 0 0 1.441v23.316A1.44 1.44 0 0 0 1.441 26.2h12.548V16.046h-3.405v-3.93h3.406V9.169a4.77 4.77 0 0 1 5.082-5.239 26.54 26.54 0 0 1 3.052.157v3.536h-2.083c-1.65 0-1.965.786-1.965 1.926v2.528h3.93l-.511 3.93h-3.419V26.2h6.68a1.44 1.44 0 0 0 1.444-1.443V1.441A1.44 1.44 0 0 0 24.757 0z",
        fill: "currentColor"
      }
    )
  );
};

const Filtrate = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "16.049",
      height: "11.575",
      viewBox: "0 0 16.049 11.575"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "g",
      {
        id: "Gruppe_12",
        "data-name": "Gruppe 12",
        transform: "translate(-1078.6 -672.6)"
      },
      /* @__PURE__ */ React__default["default"].createElement(
        "line",
        {
          id: "Linie_146",
          "data-name": "Linie 146",
          x2: "14.249",
          transform: "translate(1079.5 673.5)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.8"
        }
      ),
      /* @__PURE__ */ React__default["default"].createElement(
        "line",
        {
          id: "Linie_147",
          "data-name": "Linie 147",
          x2: "9.47",
          transform: "translate(1081.889 678.388)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.8"
        }
      ),
      /* @__PURE__ */ React__default["default"].createElement(
        "line",
        {
          id: "Linie_148",
          "data-name": "Linie 148",
          x2: "3.584",
          transform: "translate(1084.833 683.275)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.8"
        }
      )
    )
  );
};

const Attachments = ({ attachments, className }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("bg-[#fef7ec] px-6 py-8 lg:max-w-3xl", className)
    },
    /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-7" }, t("ui.contentAttachmentLabel")),
    /* @__PURE__ */ React__default["default"].createElement("ul", { className: "text-base" }, attachments == null ? void 0 : attachments.map(({ title, Link: Link2 }, index) => {
      return /* @__PURE__ */ React__default["default"].createElement("li", { key: index, className: "text-blue-900 group last:mb-0 mb-5" }, /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "ring-orange-500 ring-offset-[#fef7ec] flex focus:outline-none focus-visible:ring-2 ring-offset-8" }, /* @__PURE__ */ React__default["default"].createElement(
        Download,
        {
          className: "h-4 h-4 mt-1 group-hover:text-blue-500 duration-300"
        }
      ), /* @__PURE__ */ React__default["default"].createElement(
        "h3",
        {
          className: "ml-3 flex-1 text-blue-900 font-serif group-hover:text-blue-500 group-hover:underline duration-300"
        },
        title
      )));
    }))
  );
};

const BlockTeaserItem = ({
  Title,
  Description,
  Link: Link2,
  className,
  Image: Image2,
  Subtitle
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "li",
    {
      className: classNames__default["default"](
        "text-grey-900 bg-blue-100 list-none duration-300",
        className
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "group hover:ring-orange-500 focus:ring-orange-500 block h-full focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1" }, Image2 ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-center bg-white border border-blue-100 box-border" }, /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "inline-block w-full max-w-full  box-border" })) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5" }, /* @__PURE__ */ React__default["default"].createElement("h3", { className: "font-serif" }, /* @__PURE__ */ React__default["default"].createElement(Title, null)), Subtitle ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-green-500 font-serif" }, /* @__PURE__ */ React__default["default"].createElement(Subtitle, null)) : null, Description ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm font-light" }, /* @__PURE__ */ React__default["default"].createElement(Description, null)) : null))
  );
};

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
const BlockTeaserList = ({ items }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "my-5 sm:my-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
    },
    items.map((item, index) => /* @__PURE__ */ React__default["default"].createElement(BlockTeaserItem, __spreadValues$l({ key: index, className: "my-4 mx-4" }, item)))
  );
};

const ContentHubTags = ({ tags, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "text-black text-xs font-light tracking-wider leading-none",
        className
      )
    },
    tags.map(({ id, title, Link }) => /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        key: id,
        className: "inline-block mb-4 last:mr-0 mr-4 px-2 py-1 bg-gray-100 focus:bg-green-400 hover:bg-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900"
      },
      title
    ))
  );
};

const CompanyItem = ({
  companyName,
  description,
  Link: Link2,
  className,
  Image: Image2,
  countryCode,
  city
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "li",
    {
      className: classNames__default["default"](
        "text-grey-900 bg-blue-100 list-none duration-300",
        className
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "group hover:ring-orange-500 focus:ring-orange-500 block focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1" }, Image2 ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-center py-3 max-h-48 bg-white border border-blue-100 box-border" }, /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "inline-block w-auto max-w-full max-h-40 box-border" })) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5" }, /* @__PURE__ */ React__default["default"].createElement("h3", { className: "font-serif" }, companyName), countryCode ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-green-500 font-serif text-base" }, city ? /* @__PURE__ */ React__default["default"].createElement("span", null, city, ",") : null, " ", t(`country.name.${countryCode}`)) : null, description ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm font-light" }, description) : null))
  );
};

const Pagination = ({
  currentPage = 1,
  itemsCount = 0,
  itemsPerPage = 12,
  displayPages = 6,
  fragment,
  Link: Link2
}) => {
  const t = i18n.useTranslations();
  const totalPages = Math.ceil(itemsCount / itemsPerPage);
  const firstPageToDisplay = Math.max(
    1,
    Math.min(
      totalPages - displayPages + 1,
      currentPage - Math.floor((displayPages - 1) / 2)
    )
  );
  const lastPageToDisplay = Math.min(
    totalPages,
    Math.max(displayPages, currentPage + Math.floor(displayPages / 2))
  );
  const lastPage = totalPages;
  const pages = lodash.range(firstPageToDisplay, lastPageToDisplay + 1);
  const hasPreviousPage = currentPage > 1;
  const hasNextPage = currentPage < lastPage;
  return itemsCount && itemsCount > itemsPerPage ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex justify-center my-5 w-full" }, /* @__PURE__ */ React__default["default"].createElement(
    "nav",
    {
      className: "relative z-0 flex gap-2 cursor-pointer select-none",
      "aria-label": "Pagination"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      Link2,
      {
        className: classNames__default["default"](
          "relative inline-flex items-center px-3 py-1 hover:text-white text-xs font-medium bg-blue-100 hover:bg-blue-500 uppercase sm:px-4 sm:py-2",
          {
            "pointer-events-none cursor-not-allowed text-gray-500": !hasPreviousPage
          }
        ),
        fragment: fragment || "main-content",
        query: {
          page: String(currentPage - 1)
        }
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "sm:hidden" }, "\u2039"),
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "hidden sm:inline-block" }, t("pager.previous"))
    ),
    pages.map((page) => /* @__PURE__ */ React__default["default"].createElement(
      Link2,
      {
        key: page,
        className: classNames__default["default"](
          "relative inline-flex items-center px-3 py-1 text-xs font-medium sm:px-4 sm:py-2",
          {
            " bg-blue-100 hover:bg-blue-500 hover:text-white": page !== currentPage,
            "bg-blue-500 hover:bg-blue-500 text-white": page === currentPage
          }
        ),
        fragment: fragment || "main-content",
        query: {
          page: String(page)
        }
      },
      page
    )),
    /* @__PURE__ */ React__default["default"].createElement(
      Link2,
      {
        className: classNames__default["default"](
          "relative inline-flex items-center px-3 py-1 hover:text-white text-xs font-medium bg-blue-100 hover:bg-blue-500 uppercase sm:px-4 sm:py-2",
          {
            "pointer-events-none cursor-not-allowed text-gray-500": !hasNextPage
          }
        ),
        fragment: fragment || "main-content",
        query: {
          page: String(currentPage + 1)
        }
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "sm:hidden" }, "\u203A"),
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "hidden sm:inline-block" }, t("pager.next"))
    )
  )) : null;
};

var __defProp$k = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
const CompanyForm = ({
  useForm,
  industries
}) => {
  const Form2 = useForm();
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(Form2, { className: "mb-10 p-5 md:p-10 bg-blue-100 lg:flex lg:items-end" }, /* @__PURE__ */ React__default["default"].createElement(
    "label",
    {
      className: "block text-blue-900 text-sm font-normal cursor-pointer uppercase"
    },
    t("companies.company-name"),
    /* @__PURE__ */ React__default["default"].createElement(
      formik.Field,
      {
        className: "leading-8 mt-1 block w-full lg:w-72 border-gray-300 focus:outline-none transition duration-300 focus:ring-1 focus:ring-blue-900 focus:ring-offset-1",
        type: "text",
        name: "title"
      }
    )
  ), industries && industries.length ? /* @__PURE__ */ React__default["default"].createElement(
    "label",
    {
      className: "block lg:ml-10 text-blue-900 text-sm font-normal cursor-pointer uppercase mt-5 lg:mt-0"
    },
    t("companies.industry"),
    /* @__PURE__ */ React__default["default"].createElement(
      formik.Field,
      {
        className: "leading-8 mt-1 block w-full lg:w-72 border-gray-300 focus:outline-none transition duration-300 focus:ring-1 focus:ring-blue-900 focus:ring-offset-1",
        as: "select",
        name: "industry"
      },
      /* @__PURE__ */ React__default["default"].createElement("option", { value: "" }, t("companies.all")),
      industries.map(({ title, value }) => /* @__PURE__ */ React__default["default"].createElement("option", { key: value, value }, title))
    )
  ) : null, /* @__PURE__ */ React__default["default"].createElement(
    "button",
    {
      className: "leading-8 block lg:ml-10 w-full lg:w-48 bg-orange-500 ring-orange-500 hover:text-orange-500 border-orange-500 mt-5 lg:mt-0 px-6 py-2 w-full text-gray-900 whitespace-nowrap text-base font-bold hover:bg-white border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1",
      type: "submit"
    },
    t("companies.search")
  ));
};
const CompanyResult = ({
  useCompanySearch,
  usePagination
}) => {
  const itemsPerPage = 15;
  const { isFetching, data, status } = useCompanySearch(itemsPerPage);
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("opacity-100 transition duration-500", {
        "opacity-25 grayscale animate-pulse": isFetching && status !== "loading"
      })
    },
    (data == null ? void 0 : data.items) && (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ React__default["default"].createElement(
      Masonry__default["default"],
      {
        breakpointCols: {
          default: 3,
          1280: 3,
          1024: 2,
          640: 1
        },
        className: "flex gap-6 w-auto",
        columnClassName: "bg-clip-padding"
      },
      data == null ? void 0 : data.items.map((item, index) => /* @__PURE__ */ React__default["default"].createElement(CompanyItem, __spreadValues$k({ key: index, className: "mb-6" }, item)))
    ) : /* @__PURE__ */ React__default["default"].createElement("p", null, t("companies.no-result")),
    /* @__PURE__ */ React__default["default"].createElement(
      Pagination,
      __spreadProps$9(__spreadValues$k({}, usePagination()), {
        itemsCount: data == null ? void 0 : data.total,
        itemsPerPage
      })
    )
  );
};
const Company = ({
  industries,
  useForm,
  useCompanySearch,
  usePagination
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(CompanyForm, { industries, useForm }), /* @__PURE__ */ React__default["default"].createElement(
    CompanyResult,
    {
      useCompanySearch,
      usePagination
    }
  ));
};

const formatSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} Bytes`;
  } else if (bytes < 1048576) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  } else if (bytes < 1073741824) {
    return `${(bytes / 1048576).toFixed(2)} MB`;
  }
  return `${(bytes / 1073741824).toFixed(2)} GB`;
};

const formatType = (type) => {
  const [, subtype] = type.split("/", 2);
  const typesMap = [
    {
      types: ["ms-excel", "spreadsheetml"],
      label: "Excel"
    },
    {
      types: ["ms-powerpoint", "presentationml"],
      label: "Powerpoint"
    },
    {
      types: ["ms-word", "wordprocessingml", "msword"],
      label: "Word"
    },
    {
      types: ["opendocument.text"],
      label: "OpenDocument text"
    },
    {
      types: ["opendocument.spreadsheet"],
      label: "OpenDocument spreadsheet"
    },
    {
      types: ["opendocument.presentation"],
      label: "OpenDocument presentation"
    },
    {
      types: ["jpeg", "jpg"],
      label: "jpeg/jpg"
    },
    {
      types: ["png"],
      label: "png"
    },
    {
      types: ["gif"],
      label: "gif"
    },
    {
      types: ["svg"],
      label: "svg"
    },
    {
      types: ["html"],
      label: "html"
    },
    {
      types: ["pdf"],
      label: "pdf"
    },
    {
      types: [
        "aac",
        "midi",
        "x-midi",
        "wav",
        "opus",
        "audio/ogg",
        "audio/mpeg",
        "audio/webm",
        "audio/3gpp",
        "audio/3gpp2"
      ],
      label: "audio"
    },
    {
      types: [
        "x-msvideo",
        "mp2t",
        "video/mpeg",
        "video/ogg",
        "video/webm",
        "video/3gpp",
        "video/3gpp2"
      ],
      label: "video"
    },
    {
      types: ["plain"],
      label: "text"
    },
    {
      types: ["woff", "woff2", "ttf", "otf", "ms-fontobject"],
      label: "font"
    }
  ];
  return typesMap.filter(
    ({ types }) => types.includes(type.toLowerCase()) || types.includes(subtype.toLowerCase()) || types.find((mappedType) => {
      return subtype.toLowerCase().match(mappedType);
    })
  ).map(({ label }) => label.toUpperCase()).join(", ");
};

const Document = ({
  title,
  size,
  mime,
  caption,
  Link: Link2,
  className
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    Link2,
    {
      target: "_blank",
      rel: "noreferrer",
      className: classNames__default["default"](
        "group ring-orange-500 flex items-center justify-between mt-5 p-5 bg-blue-100 hover:bg-white border border-blue-100 hover:border-blue-200 focus:outline-none duration-300 focus-visible:ring-2 ring-offset-2 lg:max-w-3xl",
        className
      )
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "focus:text-blue-500 group-focus:text-blue-500 group-hover:text-blue-500 text-blue-900 font-serif text-base focus:outline-none transition duration-300" }, caption || title), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-2 text-green-500 text-sm" }, formatType(mime), " ", formatSize(size))),
    /* @__PURE__ */ React__default["default"].createElement("figure", { className: "pl-20" }, /* @__PURE__ */ React__default["default"].createElement(Pdf, { className: "w-12 h-12" }))
  );
};

const Figure = ({ type = "primary", caption, source, Link: Link2, Image: Image2 }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "figure",
    {
      className: classNames__default["default"]("w-full lg:max-w-3xl", {
        "mt-5  sm:mt-10": type === "secondary",
        "my-5  sm:my-10": type === "primary"
      })
    },
    Link2 ? /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "ring-orange-500 block focus:outline-none duration-300 focus-visible:ring-2 ring-offset-2" }, /* @__PURE__ */ React__default["default"].createElement(Image2, null)) : /* @__PURE__ */ React__default["default"].createElement(Image2, null),
    /* @__PURE__ */ React__default["default"].createElement("figcaption", { className: "mt-2 sm:mt-4" }, (caption == null ? void 0 : caption.trim()) && /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]("text-sm font-light", {
          "text-green-500": type === "primary",
          "text-white": type === "secondary"
        })
      },
      caption
    ), (source == null ? void 0 : source.trim()) && /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]("text-sm font-bold", caption && "mt-1", {
          "text-gray-900": type === "primary",
          "text-white": type === "secondary"
        })
      },
      `${t("image.sourceLabel")}: ${source}`
    ))
  );
};

const Filter = ({ FilterLink }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    FilterLink,
    {
      activeClassName: "header-link-active",
      className: "ring-orange-500 hover:text-orange-500 relative block items-center text-center text-blue-900 focus:outline-none duration-300 focus-visible:ring-4 ring-offset-8 xl:inline-flex xl:py-7 xl:px-5 xl:bg-blue-100"
    },
    /* @__PURE__ */ React__default["default"].createElement(Filtrate, { className: "mb-0.5 mx-auto w-6 h-6 xl:mr-2.5 xl:w-4 xl:h-4" }),
    /* @__PURE__ */ React__default["default"].createElement("span", { className: "text-sm xl:text-base" }, " ", t("header.my-themes")),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:bg-orange-500 group-focus:bg-orange-500 absolute bottom-0 left-0 xl:w-full xl:h-4 xl:transform xl:translate-y-1/2 xl:duration-300" })
  );
};

const FooterMenu = ({ items, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement("nav", { className }, /* @__PURE__ */ React__default["default"].createElement("ul", { className: "flex flex-wrap text-white text-sm leading-none" }, items.map(({ id, title, Link }, index) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("li", { key: id, className: "flex pt-6 pr-6 md:pr-4 last:pr-0 md:pt-0" }, index > 0 && /* @__PURE__ */ React__default["default"].createElement("span", { className: "hidden md:inline-block mr-4", key: `bullet-${id}` }, "\u2022"), Link ? /* @__PURE__ */ React__default["default"].createElement(Link, { className: "hover:text-green-400 focus:text-green-400 whitespace-nowrap focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900" }, title) : /* @__PURE__ */ React__default["default"].createElement("span", { className: "whitespace-nowrap" }, title))))));
};

const FooterTags = ({ tags, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "text-black text-xs tracking-wider leading-none",
        className
      )
    },
    tags.map(({ id, title, Link }) => /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        key: id,
        className: "inline-block mb-4 last:mr-0 mr-4 px-2 py-1 bg-gray-100 focus:bg-green-400 hover:bg-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900"
      },
      title
    ))
  );
};

const InfoBox = ({ Content, className, Image: Image2, Title }) => /* @__PURE__ */ React__default["default"].createElement(
  "div",
  {
    className: classNames__default["default"]("mt-7 lg:max-w-3xl", className, {
      "md:flex": Content && Image2
    })
  },
  Image2 ? /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("block w-60", {
        "mr-10 mb-5 md:mb-0": Content
      })
    },
    /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "block w-60 mt-1" })
  ) : null,
  Content || Title ? /* @__PURE__ */ React__default["default"].createElement("div", null, Title ? /* @__PURE__ */ React__default["default"].createElement(
    Title,
    {
      classNames: {
        h2: "font-bold text-blue-900 md:text-xl mb-3",
        h3: "font-bold text-blue-900 md:text-lg mb-3",
        h4: "font-bold text-blue-900 mb-3"
      }
    }
  ) : null, Content ? /* @__PURE__ */ React__default["default"].createElement(
    Content,
    {
      classNames: {
        a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
      }
    }
  ) : null) : null
);

const InfoBoxList = ({
  title,
  className,
  children,
  type = "primary"
}) => /* @__PURE__ */ React__default["default"].createElement(
  "div",
  {
    className: classNames__default["default"]("px-6 py-8  lg:max-w-3xl", className, {
      "bg-blue-100": type === "primary",
      "bg-[#F4F2EC]": type === "secondary"
    })
  },
  title && /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-7" }, title),
  /* @__PURE__ */ React__default["default"].createElement("div", null, children)
);

const LinkList = ({ links, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "ul",
    {
      className: classNames__default["default"]("bg-[#F7F7F0] px-6 py-8 lg:max-w-3xl", className)
    },
    links.map(({ id, title, description, Link }) => /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        key: id,
        className: "group last:mb-0 mb-5 first:pt-0 pt-5 first:border-0 border-t border-gray-100 cursor-pointer"
      },
      /* @__PURE__ */ React__default["default"].createElement(Link, { className: "ring-orange-500 ring-offset-[#F7F7F0] block focus:outline-none focus-visible:ring-2 ring-offset-8" }, /* @__PURE__ */ React__default["default"].createElement(
        "h3",
        {
          className: "inline-block text-blue-900 text-lg font-serif mb-2 group-hover:underline group-hover:text-blue-500  transition duration-300"
        },
        title
      ), description && /* @__PURE__ */ React__default["default"].createElement("p", { className: "group-hover:text-blue-900 duration-300" }, description))
    ))
  );
};

const MainMenu = ({ items }) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-blue-900 text-base xl:flex" }, items == null ? void 0 : items.map(({ id, title, Link }) => /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      key: id,
      className: "mx-5 my-4 border-b border-dashed border-gray-300 last:border-transparent xl:mx-3 xl:my-0 xl:border-none"
    },
    Link ? /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        className: "group ring-orange-500 sm:focus-visible:ring-0 relative block pb-4 hover:text-blue-500 focus:outline-none duration-300 focus-visible:ring-2 ring-offset-2 xl:inline-block xl:pb-5",
        activeClassName: "header-link-active"
      },
      title,
      /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:bg-orange-500 group-focus:bg-orange-500 absolute bottom-0 left-0 xl:w-full xl:h-4 xl:transform xl:translate-y-1/2 xl:duration-300" })
    ) : /* @__PURE__ */ React__default["default"].createElement("div", { className: "pb-4 xl:pb-0" }, title)
  )));
};

const TopicTags = ({ tags, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("text-xs tracking-wider leading-none", className)
    },
    tags.map(({ id, title, Link, variant = "parent" }) => /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        key: id,
        className: classNames__default["default"](
          "inline-block mb-3 last:mr-0 mr-4 px-2 py-1 hover:text-black text-white focus:outline-none transition duration-300 focus-visible:ring-2 ring-offset-2",
          {
            "bg-green-500 focus:bg-green-400 hover:bg-green-400 ring-offset-blue-900 ring-green-500": variant === "child"
          },
          {
            "bg-gray-500  focus:bg-gray-300 hover:bg-gray-300 ring-offset-blue-900 ring-gray-500": variant === "parent"
          }
        )
      },
      title
    ))
  );
};

const MainTeaser = ({
  Title,
  Description,
  date,
  Link: Link2,
  className,
  Image: Image2,
  tags,
  hasImageDisplayed,
  typename
}) => {
  const t = i18n.useTranslations();
  const topicTypeToVariant = (typename2) => {
    switch (typename2) {
      case "News":
        return t("teasers.news");
      case "Context":
        return t("teasers.context");
      case "PressRelease":
        return t("teasers.press-release");
      case "Podcast":
        return t("teasers.podcast");
      case "Video":
        return t("teasers.video");
      case "Bulletin":
        return t("teasers.bulletin");
      case "FactSheet":
        return t("teasers.factSheet");
      case "MultimediaDossier":
        return t("teasers.multimediaDossier");
      case "Event":
        return t("teasers.event");
      case "TopicCollection":
        return t("teasers.topicCollection");
    }
  };
  const typenameTranslation = topicTypeToVariant(typename);
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](className) }, /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "group hover:ring-orange-500 focus:ring-orange-500 md:aspect-h-8 md:aspect-w-16 relative block focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1 md:overflow-hidden" }, /* @__PURE__ */ React__default["default"].createElement("div", null, hasImageDisplayed && Image2 ? /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "w-full max-w-full" }) : null, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "left-0 top-0 hidden w-full h-full md:absolute md:block",
        {
          "bg-black opacity-30": Image2,
          "bg-blue-900": !Image2
        }
      )
    }
  ), /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "p-5 lg:p-10 text-white md:absolute md:bottom-0 bg-blue-900 md:bg-transparent"
    },
    Title && /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-serif text-2xl" }, /* @__PURE__ */ React__default["default"].createElement(Title, null)),
    date ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm font-medium" }, date, /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, typenameTranslation))) : null,
    Description ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm font-light" }, /* @__PURE__ */ React__default["default"].createElement(Description, null)) : null,
    tags ? /* @__PURE__ */ React__default["default"].createElement(TopicTags, { tags, className: "mt-5" }) : null
  ))));
};

const MetaMenu = ({ items }) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-blue-900 bg-blue-100 xl:flex xl:text-sm xl:bg-white" }, items == null ? void 0 : items.map(({ id, title, Link }) => /* @__PURE__ */ React__default["default"].createElement("div", { key: id, className: "mx-5 my-7 xl:mx-3 xl:my-0" }, Link ? /* @__PURE__ */ React__default["default"].createElement(
    Link,
    {
      className: "ring-orange-500 hover:text-blue-500 border-b hover:border-blue-500 focus:border-blue-500 border-transparent focus:outline-none transition duration-300 focus-visible:ring-2 ring-offset-2 lg:inline-block",
      activeClassName: "!border-blue-500"
    },
    title
  ) : /* @__PURE__ */ React__default["default"].createElement("div", { className: "border-b border-transparent" }, title))));
};

const Offering = ({
  title,
  contract,
  city,
  date,
  Link: Link2,
  className
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    Link2,
    {
      target: "_blank",
      rel: "noreferrer",
      className: classNames__default["default"](
        "block group ring-orange-500 mt-5 p-5 bg-blue-100 hover:bg-white border border-blue-100 hover:border-blue-200 focus:outline-none duration-300 focus-visible:ring-2 ring-offset-2 lg:max-w-3xl",
        className
      )
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "focus:text-blue-500 group-focus:text-blue-500 group-hover:text-blue-500 text-blue-900 font-serif text-base focus:outline-none transition duration-300" }, title),
    /* @__PURE__ */ React__default["default"].createElement("ul", { className: "mt-2 text-green-500 text-sm" }, contract ? /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        className: "inline-block after:content-['/'] after:inline-block after:px-5 last:after:hidden"
      },
      t("offering.contract"),
      ": ",
      contract
    ) : null, city ? /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        className: "inline-block after:content-['/'] after:inline-block after:px-5 last:after:hidden"
      },
      t("offering.where"),
      ": ",
      city
    ) : null, date ? /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        className: "inline-block after:content-['/'] after:inline-block after:px-5 last:after:hidden"
      },
      t("offering.when"),
      ": ",
      date
    ) : null)
  );
};

const Podcast = ({
  title,
  url,
  caption,
  provider,
  className
}) => {
  return /* @__PURE__ */ React__default["default"].createElement("figure", { className: classNames__default["default"]("mt-5 lg:max-w-3xl", className) }, /* @__PURE__ */ React__default["default"].createElement(
    "iframe",
    {
      className: "w-full rounded-lg shadow-lg",
      sandbox: "allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation",
      allow: "autoplay *; encrypted-media *; fullscreen *",
      height: url.match(/apple\.com/) ? 175 : url.match(/spotify\.com/) ? 152 : url.match(/libsyn\.com/) ? 90 : void 0,
      src: url
    }
  ), /* @__PURE__ */ React__default["default"].createElement("figcaption", { className: "mt-2 sm:mt-4" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-green-500 text-sm font-light" }, caption), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-1 text-gray-900 text-sm" }, /* @__PURE__ */ React__default["default"].createElement("span", { className: "font-medium" }, provider, ":"), " ", title)));
};

const References = ({ references, className }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("bg-[#faf9f7] px-6 py-8 lg:max-w-3xl", className)
    },
    /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-7" }, t("ui.contentReferencesLabel")),
    /* @__PURE__ */ React__default["default"].createElement("ul", { className: "text-blue text-base" }, references.map(({ id, title, description, Link }) => /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        key: id,
        className: "group last:mb-0 mb-5 first:pt-0 pt-5 first:border-0 border-t border-gray-100 cursor-pointer"
      },
      /* @__PURE__ */ React__default["default"].createElement(Link, { className: "ring-orange-500 ring-offset-[#faf9f7] block focus:outline-none focus-visible:ring-2 ring-offset-8" }, /* @__PURE__ */ React__default["default"].createElement(
        "h3",
        {
          className: "text-blue-900 text-lg font-serif mb-2 group-hover:text-blue-500 duration-300 group-hover:underline"
        },
        title
      ), description && /* @__PURE__ */ React__default["default"].createElement("p", { className: "group-hover:text-blue-900 duration-300" }, description))
    )))
  );
};

const RelatedArticles = ({ articles, className }) => {
  const t = i18n.useTranslations();
  const typeToDisplayName = (typename) => {
    switch (typename) {
      case "DrupalNews":
        return t("teasers.news");
      case "DrupalContext":
        return t("teasers.context");
      case "DrupalPressRelease":
        return t("teasers.press-release");
      case "DrupalPodcast":
        return t("teasers.podcast");
      case "DrupalVideo":
        return t("teasers.video");
      case "Bulletin":
        return t("teasers.factsheet");
      case "DrupalFactSheet":
        return t("teasers.factSheet");
      case "DrupalMultimediaDossier":
        return t("teasers.multimediaDossier");
      case "DrupalEvent":
        return t("teasers.event");
      case "DrupalTopicCollection":
        return t("teasers.topicCollection");
    }
  };
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("bg-[#f1eded] px-6 py-8 lg:max-w-3xl", className)
    },
    /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-7" }, t("ui.contentRelatedArticlesLabel")),
    /* @__PURE__ */ React__default["default"].createElement("ul", null, articles.map(({ id, publishedDate, title, description, type, Link }) => /* @__PURE__ */ React__default["default"].createElement(
      "li",
      {
        key: id,
        className: "group last:mb-0 mb-5 first:pt-0 pt-5 first:border-0 border-t border-gray-100 cursor-pointer"
      },
      /* @__PURE__ */ React__default["default"].createElement(Link, { className: "ring-orange-500 ring-offset-[#f1eded] block focus:outline-none focus-visible:ring-2 ring-offset-8" }, /* @__PURE__ */ React__default["default"].createElement(
        "h3",
        {
          className: "text-blue-900 font-serif group-hover:text-blue-500 duration-300 group-hover:underline"
        },
        title
      ), description && /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-base" }, description), publishedDate ? /* @__PURE__ */ React__default["default"].createElement("span", { className: "text-sm text-green-500 block mt-2" }, publishedDate, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-2" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-2" }, typeToDisplayName(type))) : null)
    )))
  );
};

const SocialShare = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]("flex space-x-6", className) }, /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: "https://twitter.com/Nuklearforum_CH",
      target: "_blank",
      rel: "noreferrer",
      className: "hover:text-green-400 focus:text-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-4 ring-offset-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement(Twitter, null)
  ), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: "https://www.facebook.com/NuklearforumSchweiz",
      target: "_blank",
      rel: "noreferrer",
      className: "hover:text-green-400 focus:text-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-4 ring-offset-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement(Facebook, null)
  ), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: "https://ch.linkedin.com/company/swiss-nuclear-forum",
      target: "_blank",
      rel: "noreferrer",
      className: "hover:text-green-400 focus:text-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-4 ring-offset-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement(LinkedIn, null)
  ), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: "https://www.youtube.com/channel/UC0XUUPrv8noxvu8QZB-Snwg",
      target: "_blank",
      rel: "noreferrer",
      className: "hover:text-green-400 focus:text-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-4 ring-offset-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement(YouTube, null)
  ), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: "https://www.instagram.com/nuklearforumschweiz",
      target: "_blank",
      rel: "noreferrer",
      className: "hover:text-green-400 focus:text-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-4 ring-offset-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement(Instagram, null)
  ));
};

const SearchSort = reactInstantsearchDom.connectSortBy(({ items, refine }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "ais-SortBy" }, /* @__PURE__ */ React__default["default"].createElement("label", { className: "sr-only", htmlFor: "search-sort" }, t("search.sort.label")), /* @__PURE__ */ React__default["default"].createElement(
    "select",
    {
      name: "search-sort",
      className: "ais-SortBy-select",
      onChange: (e) => {
        refine(e.target.value);
      }
    },
    items.map(
      (item) => /* @__PURE__ */ React__default["default"].createElement(
        "option",
        {
          className: "ais-SortBy-option",
          value: item.value,
          key: item.value,
          selected: item.isRefined
        },
        item.label
      )
    )
  ));
});

const PopoverContext = React__default["default"].createContext(
  void 0
);
const PopoverProvider = ({
  isOpen: initialIsOpen = false,
  children
}) => {
  const [isOpen, setIsOpen] = React.useState(initialIsOpen);
  const value = {
    isOpen,
    openPopover: () => setIsOpen(true),
    closePopover: () => setIsOpen(false),
    togglePopover: () => setIsOpen(!isOpen)
  };
  return /* @__PURE__ */ React__default["default"].createElement(PopoverContext.Provider, { value }, typeof children === "function" ? children(value) : children);
};
const usePopover = () => {
  const context = React.useContext(PopoverContext);
  if (context === void 0) {
    throw new Error("usePopover must be used within a PopoverProvider");
  }
  return context;
};

const ContentHubContext = React__default["default"].createContext(
  void 0
);
const ContentHubProvider = ({
  filters: initialFilters = {},
  children
}) => {
  const [filters, setFilters] = React.useState(initialFilters);
  return /* @__PURE__ */ React__default["default"].createElement(
    ContentHubContext.Provider,
    {
      value: {
        filters,
        setFilters: (filters2) => setFilters(filters2)
      }
    },
    children
  );
};
const useContentHub = () => {
  const context = React.useContext(ContentHubContext);
  if (context === void 0) {
    throw new Error("useContentHub must be used within a ContentHubProvider");
  }
  return context;
};

const PagerContext = React__default["default"].createContext(void 0);
const PagerProvider = ({
  itemsCount,
  itemsPerPage: initialItemsPerPage = 10,
  displayPages: initialDisplayPages = 6,
  currentPage,
  setCurrentPage,
  children
}) => {
  const firstPage = 1;
  const guessedLastPage = Math.max(firstPage, currentPage);
  const [itemsPerPage, setItemsPerPage] = React.useState(initialItemsPerPage);
  const [displayPages, setDisplayPages] = React.useState(initialDisplayPages);
  const [lastPage, setLastPage] = React.useState(guessedLastPage);
  const [pages, setPages] = React.useState([]);
  React.useEffect(() => {
    if (!itemsCount) {
      return;
    }
    const totalPages = Math.ceil(itemsCount / itemsPerPage);
    const firstPageToDisplay = Math.max(
      1,
      Math.min(
        totalPages - displayPages + 1,
        currentPage - Math.floor((displayPages - 1) / 2)
      )
    );
    const lastPageToDisplay = Math.min(
      totalPages,
      Math.max(displayPages, currentPage + Math.floor(displayPages / 2))
    );
    setLastPage(totalPages);
    setPages(lodash.range(firstPageToDisplay, lastPageToDisplay + 1));
  }, [itemsCount, itemsPerPage, displayPages, currentPage]);
  return /* @__PURE__ */ React__default["default"].createElement(
    PagerContext.Provider,
    {
      value: {
        currentPage,
        itemsCount: itemsCount || 0,
        itemsPerPage,
        displayPages,
        firstPage,
        lastPage,
        hasPreviousPage: currentPage > 1,
        hasNextPage: currentPage < lastPage,
        pages,
        setItemsPerPage: (itemsPerPage2) => setItemsPerPage(itemsPerPage2),
        setDisplayPages: (displayPages2) => setDisplayPages(displayPages2),
        setCurrentPage: (currentPage2) => setCurrentPage(currentPage2),
        previousPage: () => currentPage - 1 >= firstPage && setCurrentPage(currentPage - 1),
        nextPage: () => currentPage + 1 <= lastPage && setCurrentPage(currentPage + 1)
      }
    },
    children
  );
};
const usePager = () => {
  const context = React.useContext(PagerContext);
  if (context === void 0) {
    throw new Error("usePager must be used within a PagerProvider");
  }
  return context;
};

const useAppendStatusMessagesFromLocation = (messages) => {
  const t = i18n.useTranslations();
  const [showWarning] = useQueryParams.useQueryParam("show_warning", useQueryParams.StringParam);
  const [originalLanguage] = useQueryParams.useQueryParam("original_language", useQueryParams.StringParam);
  if (typeof location === "undefined") {
    return messages || [];
  }
  const statusMessages = messages || [];
  switch (showWarning) {
    case "content_language_not_available": {
      const messageKey = `status_messages.content_language_not_available_${originalLanguage}`;
      statusMessages.push(t(messageKey));
      break;
    }
  }
  return statusMessages;
};

const CookieConsentContext = React.createContext({
  videoConsent: false,
  setVideoConsent: () => {
  }
});
const CookieConsentProvider = (props) => {
  const [videoConsent, setVideoConsent] = React.useState(false);
  const [bannerLoaded, setBannerLoaded] = React.useState(false);
  const cookieGroupId = "BG101";
  React.useEffect(() => {
    let bannerInterval = void 0;
    if (!videoConsent && !bannerLoaded) {
      bannerInterval = window.setInterval(() => {
        if (document.getElementById("onetrust-accept-btn-handler")) {
          setBannerLoaded(true);
          window.clearInterval(bannerInterval);
        }
      }, 100);
    }
    if (!bannerLoaded)
      return;
    const bannerAcceptBtn = document.getElementById(
      "onetrust-accept-btn-handler"
    );
    const pcAllowAllBtn = document.getElementById(
      "accept-recommended-btn-handler"
    );
    const pcSaveBtn = document.getElementsByClassName(
      "save-preference-btn-handler onetrust-close-btn-handler"
    )[0];
    const consentGiven = () => setVideoConsent(true);
    if (bannerAcceptBtn) {
      bannerAcceptBtn.addEventListener("click", consentGiven);
    }
    if (pcAllowAllBtn) {
      pcAllowAllBtn.addEventListener("click", consentGiven);
    }
    if (pcSaveBtn) {
      pcSaveBtn.addEventListener("click", consentGiven);
    }
    return () => {
      if (bannerInterval) {
        clearInterval(bannerInterval);
      }
      if (bannerAcceptBtn) {
        bannerAcceptBtn.removeEventListener("click", consentGiven);
      }
      if (pcAllowAllBtn) {
        pcAllowAllBtn.removeEventListener("click", consentGiven);
      }
      if (pcSaveBtn) {
        pcSaveBtn.removeEventListener("click", consentGiven);
      }
    };
  });
  React.useEffect(() => {
    const getCookie = (name) => {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length == 2) {
        return true;
      }
    };
    const activeConsentGroups = (
      // @ts-ignore
      typeof OptanonActiveGroups !== "undefined" ? (
        // @ts-ignore
        OptanonActiveGroups.split(",").filter(
          (item) => item !== ""
        ) || null
      ) : []
    );
    const hasYouTubeConsent = typeof document !== "undefined" && getCookie("OptanonAlertBoxClosed") && //C0005 is the Social media cookies group
    activeConsentGroups.includes(cookieGroupId);
    if (hasYouTubeConsent) {
      setVideoConsent(hasYouTubeConsent);
    }
  });
  return /* @__PURE__ */ React__default["default"].createElement(CookieConsentContext.Provider, { value: { videoConsent, setVideoConsent } }, props.children);
};
const useCookieConsent = () => React.useContext(CookieConsentContext);

const useContentTypeTranslation = (typename) => {
  const t = i18n.useTranslations();
  switch (typename) {
    case "News":
    case "DrupalNews":
      return t("teasers.news");
    case "Context":
    case "DrupalContext":
      return t("teasers.context");
    case "PressRelease":
    case "DrupalPressRelease":
      return t("teasers.press-release");
    case "Podcast":
    case "DrupalPodcast":
      return t("teasers.podcast");
    case "Video":
    case "DrupalVideo":
      return t("teasers.video");
    case "Bulletin":
    case "DrupalBulletin":
      return t("teasers.bulletin");
    case "FactSheet":
    case "DrupalFactSheet":
      return t("teasers.factSheet");
    case "MultimediaDossier":
    case "DrupalMultimediaDossier":
      return t("teasers.multimediaDossier");
    case "Event":
    case "DrupalEvent":
      return t("teasers.event");
    case "TopicCollection":
    case "DrupalTopicCollection":
      return t("teasers.topicCollection");
  }
  return "";
};

const Pager = () => {
  const t = i18n.useTranslations();
  const {
    itemsCount,
    itemsPerPage,
    pages,
    hasPreviousPage,
    hasNextPage,
    currentPage,
    setCurrentPage,
    previousPage,
    nextPage
  } = usePager();
  return itemsCount && itemsCount > itemsPerPage ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex justify-center my-5 w-full" }, /* @__PURE__ */ React__default["default"].createElement(
    "nav",
    {
      className: "relative z-0 flex gap-2 cursor-pointer select-none",
      "aria-label": "Pagination"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: classNames__default["default"](
          "hover:ring-orange-500 focus:ring-orange-500 relative inline-flex items-center px-3 py-1 text-gray-900 text-xs font-medium bg-blue-100 focus:outline-none uppercase duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1 sm:px-4 sm:py-2",
          {
            "pointer-events-none": !hasPreviousPage
          }
        ),
        onClick: () => {
          previousPage();
        }
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "sm:hidden" }, "\u2039"),
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "hidden sm:inline-block" }, t("pager.previous"))
    ),
    pages.map((page) => /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        key: page,
        className: classNames__default["default"](
          "hover:ring-orange-500 focus:ring-orange-500 relative inline-flex items-center px-3 py-1 text-xs font-medium focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1 sm:px-4 sm:py-2",
          {
            "text-gray-900 bg-blue-100": page !== currentPage,
            "bg-blue-500 text-white": page === currentPage
          }
        ),
        onClick: () => {
          setCurrentPage(page);
        }
      },
      page
    )),
    /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: classNames__default["default"](
          "hover:ring-orange-500 focus:ring-orange-500 relative inline-flex items-center px-3 py-1 text-gray-900 text-xs font-medium bg-blue-100 focus:outline-none uppercase duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1 sm:px-4 sm:py-2",
          {
            "pointer-events-none": !hasNextPage
          }
        ),
        onClick: () => {
          nextPage();
        }
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "sm:hidden" }, "\u203A"),
      /* @__PURE__ */ React__default["default"].createElement("span", { className: "hidden sm:inline-block" }, t("pager.next"))
    )
  )) : null;
};

const ContentHubItem = ({
  title,
  leadtext,
  publishedDate,
  Image: Image2,
  Link: Link2,
  tags,
  typeName,
  isFirst,
  className
}) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](className, !!isFirst && "is-first") }, Image2 ? /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "w-full h-44 object-cover transform group-hover:scale-105 transition duration-300 ease-out" }) : null, Link2 ? /* @__PURE__ */ React__default["default"].createElement(Link2, null, title) : null, !!isFirst && /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-4 text-green-500" }, publishedDate), /* @__PURE__ */ React__default["default"].createElement("div", null, leadtext), !isFirst && /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-4 text-green-500" }, publishedDate), /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, { tags: tags || [] }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-xxs flex flex-wrap text-blue-900 tracking-wider leading-none uppercase space-x-2" }, typeName));
};

const ContentHubFocusItem = ({
  Title,
  date,
  Link: Link2,
  className,
  type
}) => {
  const t = i18n.useTranslations();
  const topicTypeToVariant = (type2) => {
    switch (type2) {
      case "News":
      case "DrupalNews":
        return t("teasers.news");
      case "Context":
      case "DrupalContext":
        return t("teasers.context");
      case "PressRelease":
      case "DrupalPressRelease":
        return t("teasers.press-release");
      case "Podcast":
      case "DrupalPodcast":
        return t("teasers.podcast");
      case "Video":
      case "DrupalVideo":
        return t("teasers.video");
      case "Bulletin":
      case "DrupalBulletin":
        return t("teasers.bulletin");
      case "FactSheet":
      case "DrupalFactSheet":
        return t("teasers.factSheet");
      case "MultimediaDossier":
      case "DrupalMultimediaDossier":
        return t("teasers.multimediaDossier");
      case "Event":
      case "DrupalEvent":
        return t("teasers.event");
      case "TopicCollection":
      case "DrupalTopicCollection":
        return t("teasers.topicCollection");
    }
  };
  const typenameTranslation = topicTypeToVariant(type);
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](className) }, /* @__PURE__ */ React__default["default"].createElement(
    Link2,
    {
      className: "group ring-orange-500 block focus:outline-none focus-visible:ring-2 ring-offset-8 ring-offset-green-100"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-green-500 text-sm" }, date, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-2" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-2" }, typenameTranslation)),
    /* @__PURE__ */ React__default["default"].createElement("h3", { className: "group-hover:underline font-serif" }, /* @__PURE__ */ React__default["default"].createElement(Title, null))
  ));
};

var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
const ContentHubResults = ({ items }) => {
  const t = i18n.useTranslations();
  return items.length ? /* @__PURE__ */ React__default["default"].createElement(
    Masonry__default["default"],
    {
      breakpointCols: {
        default: 4,
        1536: 4,
        1280: 3,
        1024: 2,
        640: 1
      },
      className: "flex gap-6 w-auto",
      columnClassName: "bg-clip-padding"
    },
    items.map((item) => /* @__PURE__ */ React__default["default"].createElement(ContentHubItem, __spreadValues$j({ key: item.id, className: "mb-6" }, item)))
  ) : /* @__PURE__ */ React__default["default"].createElement("p", { className: "w-full text-blue-500 text-base" }, t("hub.no-content-found"));
};

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
const ContentHubFocusResults = ({ items, className }) => {
  const t = i18n.useTranslations();
  if (items.length > 5) {
    items = items.slice(0, 5);
  }
  return items.length ? /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "relative flex flex-col h-full bg-green-100 overflow-y-auto",
        className
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: "lg:absolute p-5 lg:p-10 lg:top-0 lg:left-0 lg:right-0 lg:bottom-0"
      },
      /* @__PURE__ */ React__default["default"].createElement("h2", { className: "uppercase text-base font-serif mb-7 flex-1" }, t("hub.focus-title")),
      items.map((item, index) => /* @__PURE__ */ React__default["default"].createElement(
        ContentHubFocusItem,
        __spreadValues$i({
          key: item.id,
          className: classNames__default["default"]({
            "border-gray-100 border-b mb-5 pb-5": items.length - 1 !== index,
            "md:pb-5 md:mb-5": items.length - 1 === index
          })
        }, item)
      )),
      /* @__PURE__ */ React__default["default"].createElement("hr", { className: "border-0" })
    )
  ) : null;
};

const SubNavigation = ({ items, selectOnChange, activeUrl }) => {
  return items.length > 0 ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "bg-white lg:-mx-7 lg:px-7 lg:py-4" }, /* @__PURE__ */ React__default["default"].createElement(
    "select",
    {
      className: "block lg:hidden w-full border-gray-100",
      onChange: (e) => selectOnChange(e)
    },
    items.map(({ id, title, path }) => /* @__PURE__ */ React__default["default"].createElement("option", { key: id, value: path, selected: path === activeUrl }, title))
  ), /* @__PURE__ */ React__default["default"].createElement("div", { className: "hidden lg:block" }, items.map(({ Link, id, title }) => /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      key: id,
      className: "inline-block last:mr-0 mr-5 last:pr-10 whitespace-nowrap text-sm"
    },
    Link ? /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        className: "hover:text-orange-500 inline-block mt-2 pb-1 duration-300",
        activeClassName: "border-b-2 border-gray-900"
      },
      title
    ) : /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-3 pb-2" }, title)
  )))) : null;
};

const TeaserBoxItem = ({
  variant = "news",
  Title,
  Description,
  date,
  Link: Link2,
  className,
  Image: Image2,
  category,
  articlesCount,
  tags,
  hasImageDisplayed,
  typename
}) => {
  const t = i18n.useTranslations();
  const topicTypeToVariant = (typename2) => {
    switch (typename2) {
      case "News":
        return t("teasers.news");
      case "Context":
        return t("teasers.context");
      case "PressRelease":
        return t("teasers.press-release");
      case "Podcast":
        return t("teasers.podcast");
      case "Video":
        return t("teasers.video");
      case "Bulletin":
        return t("teasers.bulletin");
      case "FactSheet":
        return t("teasers.factSheet");
      case "MultimediaDossier":
        return t("teasers.multimediaDossier");
      case "Event":
        return t("teasers.event");
      case "TopicCollection":
        return t("teasers.topicCollection");
      case "KernwissenContent":
        return t("teasers.kernwissenContent");
      case "KernwissenTag":
        return t("teasers.kernwissenTag");
    }
  };
  const typenameTranslation = topicTypeToVariant(typename);
  return /* @__PURE__ */ React__default["default"].createElement(
    "li",
    {
      className: classNames__default["default"]("list-none duration-300", className, {
        "text-grey-900 bg-blue-100": variant !== "topicCollection",
        "text-white bg-blue-900": variant === "topicCollection"
      })
    },
    /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "group hover:ring-orange-500 focus:ring-orange-500 block focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "relative" }, variant === "video" || variant === "sheet" || variant === "bulletin" || variant === "multimedia_dossier" || variant === "kernwissenTag" || variant === "kernwissenContent" ? /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"](" bg-gradient-to-b", {
          "flex justify-center": (variant === "sheet" || variant === "bulletin") && !hasImageDisplayed && !Image2,
          "relative from-blue-900 to-blue-200": !hasImageDisplayed && !Image2
        })
      },
      hasImageDisplayed && Image2 ? /* @__PURE__ */ React__default["default"].createElement(
        "div",
        {
          className: "aspect-w-12 aspect-h-6 relative block overflow-hidden g-img-wrap"
        },
        /* @__PURE__ */ React__default["default"].createElement(
          Image2,
          {
            className: classNames__default["default"](
              "!absolute block w-full max-w-full object-cover h-full",
              {
                "w-full": variant !== "sheet" && variant !== "bulletin"
              }
            )
          }
        )
      ) : null,
      variant === "video" ? /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]({ "h-28": !hasImageDisplayed }) }, /* @__PURE__ */ React__default["default"].createElement(
        Play,
        {
          className: "absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-orange-500"
        }
      )) : null,
      (variant === "sheet" || variant === "bulletin") && !hasImageDisplayed && !Image2 ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "h-28" }, /* @__PURE__ */ React__default["default"].createElement(
        Pdf,
        {
          className: "absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-orange-500"
        }
      )) : null
    ) : null, hasImageDisplayed && Image2 && (variant === "news" || variant === "context" || variant === "event" || variant === "topicCollection") ? /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: "aspect-w-12 aspect-h-6 relative block overflow-hidden g-img-wrap"
      },
      /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "!absolute block w-full max-w-full object-cover h-full" })
    ) : null), /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5" }, category ? /* @__PURE__ */ React__default["default"].createElement("h4", { className: "mb-5 text-green-400 font-serif text-base" }, category) : null, date && variant === "event" ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mb-5 text-sm font-medium flex" }, /* @__PURE__ */ React__default["default"].createElement(Calendar, { className: "mr-1 w-4 h-4" }), date, /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, typenameTranslation))) : null, Title && /* @__PURE__ */ React__default["default"].createElement("h3", { className: "font-serif" }, /* @__PURE__ */ React__default["default"].createElement(Title, null)), Description ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm font-light" }, /* @__PURE__ */ React__default["default"].createElement(Description, null)) : null, date && variant !== "event" ? /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]("mt-5 text-sm", {
          "text-green-500": variant !== "topicCollection",
          "text-white": variant === "topicCollection"
        })
      },
      date,
      /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, typenameTranslation)),
      articlesCount ? /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, articlesCount)) : null
    ) : null, tags ? /* @__PURE__ */ React__default["default"].createElement(TopicTags, { tags, className: "mt-5" }) : null))
  );
};

var __defProp$h = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const TeaserBox = ({ items, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](className) }, /* @__PURE__ */ React__default["default"].createElement(
    Masonry__default["default"],
    {
      breakpointCols: {
        default: 3,
        1280: 3,
        1024: 2,
        640: 1
      },
      className: "flex gap-6 w-auto",
      columnClassName: "bg-clip-padding"
    },
    items.map((item, index) => /* @__PURE__ */ React__default["default"].createElement(TeaserBoxItem, __spreadProps$8(__spreadValues$h({ key: index }, item), { className: "mb-6" })))
  ));
};

const CustomSearchInput = ({
  currentRefinement,
  refine
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("form", { noValidate: true, action: "", role: "search", className: "w-full" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "md:flex items-center" }, /* @__PURE__ */ React__default["default"].createElement(
    "input",
    {
      autoFocus: true,
      type: "search",
      value: currentRefinement,
      onChange: (event) => refine(event.currentTarget.value),
      placeholder: t("search.input-placeholder"),
      className: "block relative leading-8 border-gray-300 focus:outline-none transition duration-300 focus:ring-1 focus:ring-blue-900 focus:ring-offset-1 w-full",
      onKeyDown: (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      }
    }
  )));
};
const SearchInput = reactInstantsearchDom.connectSearchBox(({ refine, currentRefinement }) => /* @__PURE__ */ React__default["default"].createElement(CustomSearchInput, { currentRefinement, refine }));

const Button = ({
  url,
  subtitle,
  icon
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      href: url,
      target: "_blank",
      className: "flex w-full max-w-[22rem] bg-blue-900 hover:bg-transparent transition-all duration-300 ease-in-out text-white hover:text-blue-900 items-center justify-start gap-2 py-3 ring-blue-900 border-blue-900 border focus:outline-none cursor-pointer focus:ring-1 hover:ring-1 ring-offset-1 lg:justify-center",
      rel: "noreferrer"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "mx-[20%] lg:mx-0 flex flex-row gap-2" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "w-10 h-10 min-w-10 " }, icon), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col items-start text-xl font-bold" }, /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-xs leading-[18px]" }, t("podcast_buttons.listen_on")), /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-lg leading-[20px]" }, subtitle)))
  );
};
const defaultSpotifyUrl = "https://open.spotify.com/show/7tCxfbyrje8ENtk9kIILv0";
const defaultApplyUrl = "https://podcasts.apple.com/us/podcast/nuctalk/id1556083407";
const PodcastButtons = ({ spotifyUrl, appleUrl }) => {
  if (!spotifyUrl && !appleUrl) {
    return null;
  }
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-wrap gap-2.5" }, spotifyUrl ? /* @__PURE__ */ React__default["default"].createElement(Button, { url: spotifyUrl, icon: /* @__PURE__ */ React__default["default"].createElement(SpotifyLogo, null), subtitle: "Spotify" }) : null, appleUrl ? /* @__PURE__ */ React__default["default"].createElement(
    Button,
    {
      url: appleUrl,
      icon: /* @__PURE__ */ React__default["default"].createElement(ApplePodcastsLogo, null),
      subtitle: "Apple Podcasts"
    }
  ) : null);
};
const ApplePodcastsLogo = () => /* @__PURE__ */ React__default["default"].createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className: "h-10 w-10",
    viewBox: "0 0 300 300"
  },
  /* @__PURE__ */ React__default["default"].createElement(
    "linearGradient",
    {
      id: "apple",
      x1: 150,
      x2: 150,
      y1: 0,
      y2: 300,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "stop",
      {
        offset: 0,
        style: {
          stopColor: "#f452ff"
        }
      }
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "stop",
      {
        offset: 1,
        style: {
          stopColor: "#832bc1"
        }
      }
    )
  ),
  /* @__PURE__ */ React__default["default"].createElement(
    "path",
    {
      fill: "url(#apple)",
      fillRule: "evenodd",
      d: "M294.1 260c-2.9 7.4-9.6 17.8-19.2 25.2-5.5 4.2-12.1 8.3-21.1 11-9.6 2.9-21.5 3.8-36.3 3.8h-135c-14.8 0-26.6-1-36.3-3.8-9-2.7-15.6-6.7-21.1-11-9.5-7.3-16.3-17.8-19.2-25.2C.1 245.1 0 228.2 0 217.5v-135C0 71.8.1 54.9 5.9 40c2.9-7.4 9.6-17.8 19.2-25.2 5.5-4.2 12.1-8.3 21.1-11C55.9 1 67.7 0 82.5 0h135c14.8 0 26.6 1 36.3 3.8 9 2.7 15.6 6.7 21.1 11 9.5 7.3 16.3 17.8 19.2 25.2 5.9 14.9 5.9 31.9 5.9 42.5v135c0 10.7-.1 27.6-5.9 42.5z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React__default["default"].createElement("g", { fill: "#FFF" }, /* @__PURE__ */ React__default["default"].createElement("path", { d: "M175.7 181.1c-.4-3.6-1.6-6.2-4-8.6-4.5-4.7-12.4-7.8-21.7-7.8-9.3 0-17.2 3-21.7 7.8-2.3 2.5-3.6 5-4 8.6-.8 7-.3 13 .5 22.7.8 9.2 2.3 21.5 4.2 33.9 1.4 8.9 2.5 13.7 3.5 17.1 1.7 5.6 7.8 10.4 17.5 10.4s15.9-4.9 17.5-10.4c1-3.4 2.1-8.2 3.5-17.1 1.9-12.5 3.4-24.7 4.2-33.9.9-9.7 1.3-15.7.5-22.7zM174.6 130.1c0 13.6-11 24.6-24.6 24.6s-24.6-11-24.6-24.6c0-13.6 11-24.6 24.6-24.6s24.6 11.1 24.6 24.6z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M149.7 33.2C92.3 33.4 45.3 80 44.5 137.4c-.6 46.5 29.1 86.3 70.6 100.9 1 .4 2-.5 1.9-1.5-.5-3.6-1.1-7.2-1.5-10.8-.2-1.3-1-2.3-2.1-2.9-32.8-14.3-55.7-47.2-55.3-85.3.5-50 41.3-90.7 91.2-91.1 51.1-.4 92.8 41 92.8 92 0 37.7-22.8 70.1-55.3 84.4-1.2.5-2 1.6-2.1 2.9l-1.5 10.8c-.2 1.1.9 1.9 1.9 1.5 41.1-14.4 70.6-53.6 70.6-99.6-.2-58.2-47.7-105.6-106-105.5z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M147.3 68.2c-37.4 1.4-67.4 32.3-67.9 69.7-.3 24.6 12 46.4 30.9 59.3.9.6 2.2-.1 2.2-1.2-.3-4.3-.3-8.1-.1-12.1.1-1.3-.4-2.5-1.4-3.4-11.5-10.8-18.5-26.2-18.1-43.2.8-30 24.9-54.4 54.9-55.6 32.6-1.3 59.4 24.9 59.4 57.1 0 16.4-7 31.2-18.1 41.7-.9.9-1.4 2.1-1.4 3.4.2 3.9.1 7.7-.1 12-.1 1.1 1.2 1.9 2.2 1.2 18.6-12.7 30.9-34.2 30.9-58.4.1-39.8-33.2-72.1-73.4-70.5z" }))
);
const SpotifyLogo = () => /* @__PURE__ */ React__default["default"].createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-10 w-10",
    viewBox: "0 0 223.316 223.316"
  },
  /* @__PURE__ */ React__default["default"].createElement(
    "path",
    {
      fill: "#1ed660",
      d: "M177.707 98.987c-35.992-21.375-95.36-23.34-129.719-12.912-5.519 1.674-11.353-1.44-13.024-6.958-1.672-5.521 1.439-11.352 6.96-13.029 39.443-11.972 105.008-9.66 146.443 14.936 4.964 2.947 6.59 9.356 3.649 14.31-2.944 4.963-9.359 6.6-14.31 3.653m-1.178 31.658c-2.525 4.098-7.883 5.383-11.975 2.867-30.005-18.444-75.762-23.788-111.262-13.012-4.603 1.39-9.466-1.204-10.864-5.8a8.717 8.717 0 0 1 5.805-10.856c40.553-12.307 90.968-6.347 125.432 14.833 4.092 2.52 5.38 7.88 2.864 11.968m-13.663 30.404a6.954 6.954 0 0 1-9.569 2.316c-26.22-16.025-59.223-19.644-98.09-10.766a6.955 6.955 0 0 1-8.331-5.232 6.95 6.95 0 0 1 5.233-8.334c42.533-9.722 79.017-5.538 108.448 12.446a6.96 6.96 0 0 1 2.31 9.57M111.656 0C49.992 0 0 49.99 0 111.656c0 61.672 49.992 111.66 111.657 111.66 61.668 0 111.659-49.988 111.659-111.66C223.316 49.991 173.326 0 111.657 0"
    }
  )
);

const hasMeaningfulCaption = (caption) => {
  return !!caption && caption.trim().length > 0;
};
const BlockMediaGallery = ({
  displayType,
  images,
  className
}) => {
  const isSlider = displayType === "SLIDER";
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const cancelButtonRef = React.useRef(null);
  const openImageDialog = (index) => {
    setSelectedImage(index);
    setIsOpen(true);
  };
  const closeImageDialog = () => {
    setIsOpen(false);
  };
  if (isSlider) {
    return /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]("my-5 sm:my-10", className) }, /* @__PURE__ */ React__default["default"].createElement(
      react.Swiper,
      {
        modules: [modules.Navigation, modules.Pagination],
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: true,
        pagination: { clickable: true },
        className: "media-gallery-swiper overflow-hidden"
      },
      images.map((item, index) => {
        const hasCaption = hasMeaningfulCaption(item.caption);
        return /* @__PURE__ */ React__default["default"].createElement(react.SwiperSlide, { key: index, className: "text-grey-900" }, /* @__PURE__ */ React__default["default"].createElement(
          "div",
          {
            className: classNames__default["default"](
              "relative list-none duration-300",
              hasCaption ? "bg-blue-100" : "bg-white"
            )
          },
          /* @__PURE__ */ React__default["default"].createElement(
            "div",
            {
              className: classNames__default["default"](
                "bg-white box-border",
                hasCaption ? "border border-blue-100" : ""
              )
            },
            item.image && /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-center" }, /* @__PURE__ */ React__default["default"].createElement(item.image, { className: "w-full h-auto object-cover" }))
          ),
          hasCaption && /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5 font-serif" }, item.caption)
        ));
      })
    ));
  }
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "my-5 sm:my-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
        className
      )
    },
    images.map((item, index) => {
      const hasCaption = hasMeaningfulCaption(item.caption);
      return /* @__PURE__ */ React__default["default"].createElement(
        "div",
        {
          key: index,
          className: classNames__default["default"](
            "relative overflow-hidden cursor-pointer list-none duration-300 group hover:ring-orange-500 focus:ring-orange-500 hover:ring focus:ring hover:ring-1 focus:ring-1 ring-offset-1 h-full flex flex-col",
            hasCaption ? "bg-blue-100 text-grey-900" : "bg-white"
          ),
          onClick: () => openImageDialog(index)
        },
        /* @__PURE__ */ React__default["default"].createElement(
          "div",
          {
            className: classNames__default["default"](
              "bg-white box-border flex-grow",
              hasCaption ? "border border-blue-100" : ""
            )
          },
          item.image && /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-center h-full" }, /* @__PURE__ */ React__default["default"].createElement(item.image, { className: "w-full h-full object-cover" }))
        ),
        hasCaption && /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5 font-serif mt-auto" }, item.caption)
      );
    })
  ), isOpen && selectedImage !== null && images[selectedImage] && /* @__PURE__ */ React__default["default"].createElement(
    react$1.Dialog,
    {
      open: isOpen,
      onClose: closeImageDialog,
      className: "fixed inset-0 z-50 overflow-y-auto",
      initialFocus: cancelButtonRef
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }, /* @__PURE__ */ React__default["default"].createElement(
      react$1.Dialog.Overlay,
      {
        className: "fixed inset-0 bg-black bg-opacity-75",
        onClick: closeImageDialog
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "span",
      {
        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
        "aria-hidden": "true"
      },
      "\u200B"
    ), /* @__PURE__ */ React__default["default"].createElement("div", { className: "inline-block align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl w-full border border-blue-100" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "relative" }, /* @__PURE__ */ React__default["default"].createElement(
      react.Swiper,
      {
        modules: [modules.Navigation, modules.Pagination],
        initialSlide: selectedImage,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: true,
        pagination: { clickable: true },
        className: "media-gallery-swiper-dialog"
      },
      images.map((item, index) => /* @__PURE__ */ React__default["default"].createElement(react.SwiperSlide, { key: index }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "max-h-[90vh] overflow-hidden bg-white flex items-center justify-center" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "w-full h-full flex items-center justify-center" }, /* @__PURE__ */ React__default["default"].createElement(item.image, { className: "max-h-[90vh] w-auto max-w-full" }))), hasMeaningfulCaption(item.caption) && /* @__PURE__ */ React__default["default"].createElement("div", { className: "p-5 bg-blue-100 text-grey-900 font-serif" }, item.caption)))
    ), /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        type: "button",
        ref: cancelButtonRef,
        onClick: closeImageDialog,
        className: "absolute top-4 right-4 bg-white p-2 text-blue-900 hover:text-blue-500 focus:text-blue-500 transition duration-300 ring-orange-500 focus:outline-none focus-visible:ring-4 ring-offset-2 z-10",
        "aria-label": "Close"
      },
      /* @__PURE__ */ React__default["default"].createElement(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          className: "h-6 w-6",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        },
        /* @__PURE__ */ React__default["default"].createElement(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
          }
        )
      )
    ))))
  ));
};

var __defProp$g = Object.defineProperty;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
const Heading = ({
  className,
  title,
  Description,
  subNavigation,
  setIsFormOpen,
  isFormOpen,
  localStorage
}) => {
  const filtersActive = () => {
    let filtersCount = 0;
    Object.keys(localStorage).forEach(function(key) {
      if (key !== "page" && localStorage[key].length) {
        filtersCount = filtersCount + 1;
      }
    });
    return !!filtersCount;
  };
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, !isFormOpen ? /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "px-5 w-screen max-w-full bg-blue-900 sm:px-10",
        className,
        subNavigation ? "pt-10" : "py-10"
      )
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, title ? /* @__PURE__ */ React__default["default"].createElement(
      "h1",
      {
        className: classNames__default["default"](
          "text-white font-serif text-2xl sm:text-3xl md:text-4xl md:leading-tight",
          { "mb-5": !!Description }
        )
      },
      title
    ) : null, Description ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "max-w-7xl text-white lg:flex lg:justify-between" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "max-w-3xl" }, /* @__PURE__ */ React__default["default"].createElement(
      Description,
      {
        classNames: {
          a: "hover:text-green-400 focus:text-green-400 underline focus:outline-none duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900"
        }
      }
    )), setIsFormOpen && localStorage ? /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: "flex items-center justify-center leading-8 relative inline-block w-full bg-white lg:w-72 ring-orange-500 hover:text-orange-500 mt-5 lg:mt-0 px-6 py-2 w-full text-gray-900 whitespace-nowrap text-base font-bold  border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-2 focus:ring-offset-4 hover:ring-1 ring-offset-1 ring-offset-blue-900",
        onClick: () => setIsFormOpen(true)
      },
      /* @__PURE__ */ React__default["default"].createElement(Filtrate, { className: "mr-3" }),
      /* @__PURE__ */ React__default["default"].createElement("span", null, t("my-topics.open-form")),
      filtersActive() ? /* @__PURE__ */ React__default["default"].createElement(
        "span",
        {
          className: "inline-block bg-orange-500 w-6 h-6 rounded-full absolute right-0 top-0 transform -translate-y-1/2 translate-x-1/2"
        }
      ) : null
    )) : null) : null, subNavigation ? /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]({ "pt-10": subNavigation }) }, /* @__PURE__ */ React__default["default"].createElement(SubNavigation, __spreadValues$g({}, subNavigation))) : null)
  ) : null);
};

const Home = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      }
    )
  );
};

const RichText = ({ Content, prose = true, color = "black" }) => {
  const proseClass = {
    white: "prose-white",
    black: "prose"
  }[color];
  return prose ? /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "sm:prose-lg md:prose-xl lg:max-w-3xl",
        proseClass,
        {
          "my-5 sm:my-10": color === "black"
        }
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Content, null)
  ) : /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(
    Content,
    {
      classNames: {
        a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
      }
    }
  ));
};

const H1 = ({ children, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "h1",
    {
      className: classNames__default["default"](
        "text-blue-900 font-serif text-2xl sm:text-3xl md:text-4xl md:leading-tight",
        className
      )
    },
    children
  );
};

const H2 = ({ children, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "h2",
    {
      className: classNames__default["default"](
        "text-blue-900 font-serif text-lg sm:text-xl md:text-2xl md:leading-tight",
        className
      )
    },
    children
  );
};

const H3 = ({ children, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "h3",
    {
      className: classNames__default["default"](
        "text-blue-900 font-serif text-base sm:text-lg md:text-xl md:leading-tight",
        className
      )
    },
    children
  );
};

const H4 = ({ children, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "h4",
    {
      className: classNames__default["default"](
        "text-blue-900 font-serif text-sm sm:text-base md:text-lg md:leading-tight",
        className
      )
    },
    children
  );
};

const HamburgerMenu = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 6h16M4 12h16M4 18h16"
      }
    )
  );
};

const Instagram = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      className
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
        fill: "currentColor"
      }
    )
  );
};

const YouTube = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 33.893 23.816",
      width: "20",
      height: "20",
      className
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M33.885 8.394c.077-2.204-.405-4.391-1.4-6.359a4.5 4.5 0 0 0-2.648-1.54C25.553.106 21.25-.053 16.949.018c-4.285-.074-8.571.08-12.84.462a4.42 4.42 0 0 0-2.248 1.139C.475 2.897.321 5.083.167 6.931c-.223 3.322-.223 6.655 0 9.977a14.7 14.7 0 0 0 .462 3.079c.186.778.561 1.497 1.093 2.094a4.4 4.4 0 0 0 2.294 1.2 69.56 69.56 0 0 0 10.007.508c5.389.077 10.115 0 15.7-.431.889-.151 1.711-.57 2.356-1.2.431-.431.753-.959.939-1.54a16.29 16.29 0 0 0 .8-5.235c.067-.862.067-6.065.067-6.989zM13.47 16.307v-9.53l9.114 4.788c-2.555 1.417-5.927 3.018-9.114 4.742z",
        fill: "currentColor"
      }
    )
  );
};

const LanguageSwitcher = ({ localizations }) => {
  const { locale } = i18n.useIntl();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-baseline my-5 text-blue-900 leading-none uppercase xl:my-0 xl:text-xs" }, Object.values(i18n.locales).map(({ code, name }, index, locales2) => {
    const Link2 = localizations[code];
    return /* @__PURE__ */ React__default["default"].createElement(React.Fragment, { key: code }, !Link2 || locale === code ? /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]("mx-5 border-b xl:mx-2", {
          "border-transparent": locale !== code,
          "border-blue-900": locale === code
        }),
        key: index
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { title: name }, code.toUpperCase())
    ) : /* @__PURE__ */ React__default["default"].createElement(
      Link2,
      {
        key: index,
        className: "ring-orange-500 block mx-4 hover:text-blue-500 border-b hover:border-blue-500 focus:border-blue-500 border-transparent focus:outline-none transition duration-300 focus-visible:ring-2 ring-offset-2 xl:mx-2"
      },
      /* @__PURE__ */ React__default["default"].createElement("span", { title: name }, code.toUpperCase())
    ), index < locales2.length - 1 && /* @__PURE__ */ React__default["default"].createElement("div", null, "|"));
  }));
};

const LinkedIn = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 26.04 26.197",
      width: "20",
      height: "20",
      className
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M24.114 0H1.925A1.9 1.9 0 0 0 0 1.873v22.451A1.9 1.9 0 0 0 1.925 26.2h22.189a1.9 1.9 0 0 0 1.926-1.876V1.873A1.9 1.9 0 0 0 24.114 0zM7.898 21.927H3.969V10.138h3.93zM5.934 8.488h0c-1.129 0-2.043-.915-2.043-2.043s.915-2.043 2.043-2.043c.784-.087 1.549.283 1.968.951s.419 1.517 0 2.186-1.184 1.038-1.968.951zm16.137 13.439H18.14V15.6c0-1.585-.563-2.62-1.991-2.62a2.16 2.16 0 0 0-2.017 1.428 2.62 2.62 0 0 0-.131.956v6.549h-3.93V10.125h3.93v1.664a3.93 3.93 0 0 1 3.55-1.965c2.62 0 4.519 1.69 4.519 5.318z",
        fill: "currentColor"
      }
    )
  );
};

const Logo = ({ monochrome = false, className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "125",
      height: "66",
      viewBox: "0 0 250 132"
    },
    /* @__PURE__ */ React__default["default"].createElement("g", { fill: monochrome ? "#FFF" : "#004d5f" }, /* @__PURE__ */ React__default["default"].createElement("path", { d: "M8.35 49.15l.17 10.01-.05.01-6.2-9.91L0 49.3.24 63.04 2.5 63l-.17-10.02.06-.01 6.2 9.92 2.25-.04-.23-13.74-2.26.04zm16.27-.04l.15 9.21a4.28 4.28 0 0 1-1.41 3.53 5.77 5.77 0 0 1-3.83 1.29 5.57 5.57 0 0 1-3.8-1.14 4.34 4.34 0 0 1-1.51-3.47l-.16-9.21h2.27l.16 9.2a2.82 2.82 0 0 0 .84 2.16 3.09 3.09 0 0 0 2.17.68 3.23 3.23 0 0 0 2.21-.76 2.73 2.73 0 0 0 .8-2.18l-.16-9.21zM32 57.02l-1.56.02.1 5.95-2.27.04-.23-13.74 2.26-.04.1 5.82 1.3-.02 4.16-5.9 2.69-.05-4.83 6.65 5.45 7.09-2.77.04-4.4-5.86zm11.54 4.11l6.24-.11.03 1.84-8.51.15-.24-13.74 2.27-.04.21 11.9zm16.91-4.44l-5.94.11.08 4.34 6.89-.12.03 1.84-9.16.16-.23-13.74 9.09-.16.03 1.84-6.83.12.07 3.87 5.94-.1.03 1.84zm11 3l-5.32.09L65.1 63h-2.29l4.75-13.83h2.15l5.17 13.66h-2.31zm-4.7-1.83l4-.08L68.7 52h-.06zm12.59-.57l.1 5.7h-2.27l-.24-13.74 5-.09a5.31 5.31 0 0 1 3.54 1 3.63 3.63 0 0 1 1.29 2.94 3.13 3.13 0 0 1-.49 1.9 3.71 3.71 0 0 1-1.57 1.26 2.9 2.9 0 0 1 1.67 1.18 4 4 0 0 1 .54 2v1.14a4.21 4.21 0 0 0 .17 1.18 1.59 1.59 0 0 0 .52.87v.22h-2.33a1.51 1.51 0 0 1-.5-1 8.67 8.67 0 0 1-.13-1.31v-1.11a2.31 2.31 0 0 0-.64-1.6 2.15 2.15 0 0 0-1.65-.59zm0-1.84l2.63-.05a3 3 0 0 0 2-.56 2 2 0 0 0 .59-1.62 2.11 2.11 0 0 0-.64-1.62A2.64 2.64 0 0 0 82 51l-2.75.05zm19.31 1.56l-5.95.11.1 5.86-2.26.04-.24-13.74 9.17-.17.03 1.84-6.9.13.07 4.2 5.95-.11.03 1.84zm14.17.2a5.84 5.84 0 0 1-1.49 4.21 5.32 5.32 0 0 1-4 1.73 5.17 5.17 0 0 1-4-1.59 5.92 5.92 0 0 1-1.6-4.15v-2.47a6 6 0 0 1 1.45-4.2 5.1 5.1 0 0 1 3.88-1.74 5.3 5.3 0 0 1 4.08 1.59 5.82 5.82 0 0 1 1.64 4.14zm-2.3-2.45a4.22 4.22 0 0 0-1-2.8 3 3 0 0 0-2.47-1.06 2.79 2.79 0 0 0-2.3 1.1 4.41 4.41 0 0 0-.82 2.84v2.49a4.49 4.49 0 0 0 .92 2.83 2.84 2.84 0 0 0 2.39 1.07 3 3 0 0 0 2.44-1.15 4.42 4.42 0 0 0 .85-2.87zm7.74 2.53l.1 5.7h-2.27l-.24-13.74 5-.09a5.31 5.31 0 0 1 3.54 1 3.63 3.63 0 0 1 1.29 2.94 3.06 3.06 0 0 1-.52 1.84 3.59 3.59 0 0 1-1.57 1.26 2.92 2.92 0 0 1 1.68 1.18 4 4 0 0 1 .54 2v1.14a4.21 4.21 0 0 0 .17 1.18 1.63 1.63 0 0 0 .51.87v.22h-2.33a1.51 1.51 0 0 1-.5-1 8.67 8.67 0 0 1-.13-1.31v-1.11a2.31 2.31 0 0 0-.63-1.67 2.15 2.15 0 0 0-1.65-.59zm0-1.84l2.63-.05a3 3 0 0 0 2-.56 2 2 0 0 0 .59-1.62 2.11 2.11 0 0 0-.64-1.62 2.64 2.64 0 0 0-1.94-.6l-2.75.05zm21.28-6.34l.15 9.21a4.28 4.28 0 0 1-1.41 3.53 5.77 5.77 0 0 1-3.83 1.29 5.57 5.57 0 0 1-3.8-1.16 4.34 4.34 0 0 1-1.51-3.47L129 49.3h2.27l.16 9.2a2.82 2.82 0 0 0 .84 2.16 3.09 3.09 0 0 0 2.17.68 3.23 3.23 0 0 0 2.21-.76 2.73 2.73 0 0 0 .8-2.18l-.16-9.21zm6.35.16l4.1 10.51.05-.01 3.74-10.64 2.94-.05.23 13.75-2.26.03-.09-4.68.12-5.96-.05-.01-3.85 10.72-1.52.03-4.19-10.55-.06.01.33 5.93.08 4.68-2.27.04-.23-13.74 2.93-.06zm28.24 10.24a2.32 2.32 0 0 0-.86-1.82 7.61 7.61 0 0 0-2.92-1.21 9.12 9.12 0 0 1-3.4-1.41 3 3 0 0 1-1.19-2.43 3.09 3.09 0 0 1 1.24-2.59 5.31 5.31 0 0 1 3.28-1 4.86 4.86 0 0 1 3.41 1.12A3.65 3.65 0 0 1 175 53v.06h-1a2.93 2.93 0 0 0-1-2.25 3.72 3.72 0 0 0-2.7-.81 4 4 0 0 0-2.54.78 2.26 2.26 0 0 0-.89 1.85 2.11 2.11 0 0 0 .88 1.71 7.72 7.72 0 0 0 2.95 1.17 8.49 8.49 0 0 1 3.36 1.49 3.18 3.18 0 0 1 1.19 2.52 3.06 3.06 0 0 1-1.25 2.59 5.58 5.58 0 0 1-3.37 1 6.18 6.18 0 0 1-3.57-1 3.32 3.32 0 0 1-1.52-3v-.06h1a2.64 2.64 0 0 0 1.23 2.35 5 5 0 0 0 2.8.72 4.38 4.38 0 0 0 2.6-.76 2.25 2.25 0 0 0 1-1.91m13.73-.89v.06a4.52 4.52 0 0 1-4.81 4.52 4.51 4.51 0 0 1-3.68-1.59 6.43 6.43 0 0 1-1.41-4.26v-2.24a6.48 6.48 0 0 1 1.31-4.32 4.57 4.57 0 0 1 3.56-1.73 4.91 4.91 0 0 1 3.45 1.1 4.77 4.77 0 0 1 1.5 3.25h0-1.05a4.28 4.28 0 0 0-1.2-2.59 3.65 3.65 0 0 0-2.67-.86 3.44 3.44 0 0 0-2.84 1.44 5.68 5.68 0 0 0-1 3.6v2.25a5.78 5.78 0 0 0 1.14 3.58 3.47 3.47 0 0 0 2.89 1.34 3.74 3.74 0 0 0 2.64-.93 4.17 4.17 0 0 0 1.11-2.67zm13.62 4.3l-1.11.02-.11-6.33-7.72.14.11 6.33-1.11.01-.24-13.74 1.11-.02.11 6.46 7.72-.14-.11-6.45 1.11-.02.24 13.74zm6.58-3.72l.45 2.09.06.01.47-2.12 2.7-9.91 1.06-.01 3.04 9.8.53 2.11.06-.01.4-2.12 2.29-9.89 1.13-.03-3.25 13.81-1.05.02-3.24-10.49-.37-1.44h-.06l-.32 1.45-2.9 10.6-1.06.02-3.73-13.69 1.15-.01 2.64 9.81z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M231.16 56.22l-6.54.12.1 5.69 7.49-.13.01.96-8.59.15-.24-13.74 8.55-.15.02.96-7.45.13.09 5.17 6.54-.12.02.96zm4.195-7.016l1.12-.019.237 13.738-1.12.019zm4.995.076l.02.97 7.75-.14-7.8 12.05.02.87 9.66-.17-.02-.96-8.32.14 7.82-12.09-.01-.83-9.12.16zM0 69.34l.23 13.51 2.23-.04-.1-5.76 5.85-.11-.03-1.81-5.85.11-.07-4.13 6.79-.12-.04-1.81-9.01.16zm22.14 7.8a5.75 5.75 0 0 1-1.46 4.13 5.18 5.18 0 0 1-4 1.7 5 5 0 0 1-3.93-1.56 5.79 5.79 0 0 1-1.57-4.07V74.9a5.81 5.81 0 0 1 1.43-4.12 5 5 0 0 1 3.86-1.7 5.22 5.22 0 0 1 4 1.56 5.69 5.69 0 0 1 1.61 4.07zm-2.26-2.41a4.24 4.24 0 0 0-.94-2.73 3 3 0 0 0-2.43-1 2.77 2.77 0 0 0-2.3 1.13 4.32 4.32 0 0 0-.81 2.79v2.45a4.43 4.43 0 0 0 .9 2.78 2.83 2.83 0 0 0 2.35 1A3 3 0 0 0 19.09 80a4.23 4.23 0 0 0 .83-2.82zm7.69 2.49l.09 5.6h-2.23l-.23-13.47 4.94-.08a5.18 5.18 0 0 1 3.47 1 3.56 3.56 0 0 1 1.27 2.89 3.1 3.1 0 0 1-.5 1.81 3.68 3.68 0 0 1-1.55 1.24 2.81 2.81 0 0 1 1.65 1.15 3.94 3.94 0 0 1 .53 2v1.13a4.43 4.43 0 0 0 .16 1.15 1.74 1.74 0 0 0 .51.86v.21h-2.3a1.57 1.57 0 0 1-.49-1 8.26 8.26 0 0 1-.12-1.29v-1.09a2.27 2.27 0 0 0-.62-1.64 2.1 2.1 0 0 0-1.62-.58zm0-1.81h2.58a3 3 0 0 0 1.95-.55 2 2 0 0 0 .58-1.6 2.11 2.11 0 0 0-.68-1.64 2.55 2.55 0 0 0-1.85-.54h-2.71zm20.91-6.23l.16 9a4.26 4.26 0 0 1-1.39 3.48A5.74 5.74 0 0 1 43.48 83a5.49 5.49 0 0 1-3.73-1.14 4.23 4.23 0 0 1-1.48-3.41l-.16-9.06h2.23l.16 9.05a2.72 2.72 0 0 0 .82 2.12 3 3 0 0 0 2.13.67 3.15 3.15 0 0 0 2.18-.75 2.64 2.64 0 0 0 .78-2.14l-.16-9zm6.25.16l4.03 10.32h.05l3.67-10.46 2.89-.05.24 13.51-2.23.04-.08-4.6.12-5.86-.06-.01-3.78 10.54-1.49.02-4.13-10.37-.05.01.32 5.83.08 4.6-2.23.04-.23-13.51 2.88-.05zm30.31 13.35l-2.22.04-6.09-9.76-.06.02.17 9.84-2.23.04-.23-13.51 2.23-.04 6.09 9.75.06-.02-.17-9.83 2.22-.04.23 13.51zm13.54-13.51l.16 9a4.26 4.26 0 0 1-1.39 3.48A5.74 5.74 0 0 1 93.58 83a5.49 5.49 0 0 1-3.73-1.14 4.2 4.2 0 0 1-1.48-3.41l-.16-9.06h2.23l.15 9.05a2.76 2.76 0 0 0 .83 2.12 3 3 0 0 0 2.13.67 3.16 3.16 0 0 0 2.18-.75 2.64 2.64 0 0 0 .78-2.14l-.16-9zm13.26 9.03v.05a4.26 4.26 0 0 1-1.26 3.36A5.13 5.13 0 0 1 107 83a4.89 4.89 0 0 1-3.83-1.53 5.79 5.79 0 0 1-1.53-4V74.9a5.81 5.81 0 0 1 1.38-4.09 4.8 4.8 0 0 1 3.72-1.67 5.27 5.27 0 0 1 3.75 1.19 4.25 4.25 0 0 1 1.39 3.36v.06h-2.15a3 3 0 0 0-.77-2.11 2.83 2.83 0 0 0-2.16-.72 2.54 2.54 0 0 0-2.26 1.08 4.47 4.47 0 0 0-.76 2.76v2.59a4.51 4.51 0 0 0 .87 2.75 2.65 2.65 0 0 0 2.24 1 2.75 2.75 0 0 0 2.08-.79 2.93 2.93 0 0 0 .68-2.13zm5.18 2.78l6.13-.1.03 1.8-8.36.15-.23-13.51 2.23-.04.2 11.7zm16.63-4.36l-5.84.1.07 4.27 6.78-.12v1.81l-9 .16-.24-13.51 8.94-.16v1.81l-6.71.12.07 3.81 5.84-.1zm-3.39-10.81h2.47 0l-2.46 2.46h-1.74zm14.19 13.76l-5.22.09-1 3.17h-2.26l4.68-13.59h2.11l5.08 13.42h-2.27zm-4.61-1.81l3.95-.07-2-5.73h-.05zm10.275-8.742l2.23-.045.27 13.51-2.23.045zm8.205 8.192l.1 5.6h-2.23L156 69.35l4.93-.08a5.18 5.18 0 0 1 3.47 1 3.56 3.56 0 0 1 1.27 2.89 3 3 0 0 1-.5 1.81 3.68 3.68 0 0 1-1.55 1.24 2.81 2.81 0 0 1 1.65 1.15 3.94 3.94 0 0 1 .53 2v1.13a4.44 4.44 0 0 0 .17 1.15 1.6 1.6 0 0 0 .51.86v.21h-2.29a1.48 1.48 0 0 1-.49-1 8.29 8.29 0 0 1-.13-1.29v-1.09a2.31 2.31 0 0 0-.61-1.64 2.11 2.11 0 0 0-1.63-.58zm0-1.81h2.58a2.93 2.93 0 0 0 1.95-.55 2 2 0 0 0 .59-1.6 2.15 2.15 0 0 0-.64-1.59 2.55 2.55 0 0 0-1.85-.54h-2.71zm18.97 1.22l-5.84.1.07 4.27 6.78-.12.03 1.81-9 .16-.24-13.51 8.94-.16.04 1.81-6.72.12.07 3.81 5.84-.1.03 1.81zm16.77 2.77a2.24 2.24 0 0 0-.85-1.79 7.45 7.45 0 0 0-2.86-1.19A8.8 8.8 0 0 1 187 75a2.85 2.85 0 0 1-1.17-2.38 3.05 3.05 0 0 1 1.21-2.55 5.24 5.24 0 0 1 3.23-1 4.75 4.75 0 0 1 3.35 1.1A3.59 3.59 0 0 1 194.9 73v.06h-1a2.9 2.9 0 0 0-1-2.21 3.6 3.6 0 0 0-2.59-.83 3.87 3.87 0 0 0-2.49.77 2.18 2.18 0 0 0-.87 1.81 2.11 2.11 0 0 0 .86 1.69 7.6 7.6 0 0 0 2.9 1.15 8.32 8.32 0 0 1 3.3 1.45 3.09 3.09 0 0 1 1.17 2.47A3 3 0 0 1 193.9 82a5.51 5.51 0 0 1-3.32 1 6.09 6.09 0 0 1-3.51-1 3.26 3.26 0 0 1-1.49-2.94V79h1a2.57 2.57 0 0 0 1.2 2.31 4.84 4.84 0 0 0 2.76.71 4.26 4.26 0 0 0 2.55-.75 2.19 2.19 0 0 0 .94-1.87m13.54-10.22l.16 9.16a4.25 4.25 0 0 1-1.27 3.4A5 5 0 0 1 203 83a4.88 4.88 0 0 1-3.45-1.11 4.26 4.26 0 0 1-1.37-3.35l-.18-9.19h1.1l.16 9.15a3.47 3.47 0 0 0 1.05 2.65A3.7 3.7 0 0 0 203 82a3.85 3.85 0 0 0 2.67-1 3.4 3.4 0 0 0 1-2.69l-.16-9.15zm4.21.1l.23 13.51 1.11-.02-.24-13.51-1.1.02zm13.36 10.12a2.24 2.24 0 0 0-.85-1.79 7.45 7.45 0 0 0-2.86-1.19 8.8 8.8 0 0 1-3.34-1.42 2.85 2.85 0 0 1-1.17-2.38 3.05 3.05 0 0 1 1.21-2.55 5.24 5.24 0 0 1 3.23-1 4.76 4.76 0 0 1 3.35 1.1A3.59 3.59 0 0 1 226 73v.06h-1a2.9 2.9 0 0 0-1-2.21 3.6 3.6 0 0 0-2.59-.83 3.87 3.87 0 0 0-2.49.77 2.18 2.18 0 0 0-.92 1.81 2.11 2.11 0 0 0 .86 1.69 7.6 7.6 0 0 0 2.9 1.15 8.32 8.32 0 0 1 3.3 1.45 3.09 3.09 0 0 1 1.17 2.47A3 3 0 0 1 225 82a5.51 5.51 0 0 1-3.32 1 6.09 6.09 0 0 1-3.51-1 3.26 3.26 0 0 1-1.49-2.94V79h1a2.58 2.58 0 0 0 1.21 2.31 4.82 4.82 0 0 0 2.76.71 4.26 4.26 0 0 0 2.55-.75 2.19 2.19 0 0 0 .94-1.87m12 0a2.3 2.3 0 0 0-.85-1.79 7.51 7.51 0 0 0-2.87-1.19 8.87 8.87 0 0 1-3.34-1.42 2.91 2.91 0 0 1-1.17-2.38 3.06 3.06 0 0 1 1.22-2.55 5.21 5.21 0 0 1 3.22-1 4.75 4.75 0 0 1 3.35 1.1A3.6 3.6 0 0 1 238 73v.06h-1a2.84 2.84 0 0 0-1-2.21 3.59 3.59 0 0 0-2.58-.83 3.9 3.9 0 0 0-2.5.77 2.23 2.23 0 0 0-.92 1.81 2.11 2.11 0 0 0 .86 1.69 7.74 7.74 0 0 0 2.9 1.15 8.31 8.31 0 0 1 3.31 1.45A3.26 3.26 0 0 1 237 82a5.47 5.47 0 0 1-3.31 1 6 6 0 0 1-3.51-1 3.25 3.25 0 0 1-1.5-2.94V79h1a2.59 2.59 0 0 0 1.2 2.31 4.86 4.86 0 0 0 2.76.71 4.22 4.22 0 0 0 2.55-.75 2.2 2.2 0 0 0 .95-1.87m4.17-10.07l.24 13.51 8.45-.15-.02-.94-7.36.13-.1-5.6 6.43-.11-.01-.95-6.43.12-.09-5.08 7.32-.13-.02-.95-8.41.15z" })),
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M209.63 46.49h-2.86l.32-.37c13.29-15.41 18.42-28.64 14-36.29-2.95-5.18-10-7.92-20.37-7.92-18.17 0-44.89 8.13-73.38 22.3 5.55 2.84 11 5.85 16.35 8.95 6.89 4 13.76 8.37 20.41 12.92l.6.41h-3.83-.06a347.08 347.08 0 0 0-18.2-11.41c-5.65-3.3-11.59-6.53-17.66-9.62-6.07 3.09-12 6.32-17.66 9.62a342.97 342.97 0 0 0-18.2 11.41h-.06-3.78l.6-.41a337.67 337.67 0 0 1 20.41-12.92 332.74 332.74 0 0 1 16.35-8.95C94.13 10 67.4 1.91 49.23 1.91c-10.37 0-17.41 2.74-20.37 7.92-4.37 7.65.76 20.88 14 36.29l.32.37h-2.81l-.06-.08C26.92 30.54 22.19 17.17 27 8.74 36-7 77.19-1 125 23c47.81-24 89-30 98-14.26 4.81 8.43.08 21.81-13.31 37.67zM49.2 132c-11.2 0-18.93-3-22.2-8.76-4.79-8.38-.14-21.66 13.08-37.41l.07-.08H43l-.32.37c-13.12 15.3-18.16 28.43-13.82 36 8.32 14.59 47.72 8.53 93.77-14.38-5.68-2.91-11.18-5.92-16.37-9a332.69 332.69 0 0 1-20-12.66l-.6-.41h3.85 0c5.73 3.84 11.73 7.59 17.81 11.15a340.65 340.65 0 0 0 17.66 9.62c6-3 11.93-6.27 17.66-9.62 6.08-3.56 12.07-7.31 17.81-11.15h.06 3.84l-.6.41a352.84 352.84 0 0 1-20 12.66c-5.18 3-10.69 6-16.37 9 46 22.91 85.44 29 93.77 14.38 4.34-7.6-.7-20.73-13.82-36l-.32-.37h2.86l.06.08c13.22 15.74 17.87 29 13.08 37.41-3.28 5.76-10.96 8.76-22.22 8.76-19 0-46.64-8.39-75.79-23-29.15 14.63-56.76 23-75.79 23z",
        fill: "#858d20"
      }
    )
  );
};

const Message = ({ children }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "mb-4 mt-1 p-4 text-green-500 bg-green-100 rounded-md" }, children);

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const MultipleSelectBadges = ({
  items,
  title,
  disabled,
  className,
  name
}) => {
  const [field, , helpers] = formik.useField(name);
  return /* @__PURE__ */ React__default["default"].createElement("fieldset", { className, disabled }, title && /* @__PURE__ */ React__default["default"].createElement("legend", { className: "block mb-4 text-gray-500 whitespace-nowrap text-sm font-medium cursor-pointer uppercase" }, title), /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]("flex flex-wrap gap-2") }, items == null ? void 0 : items.map(({ id, title: title2 }) => /* @__PURE__ */ React__default["default"].createElement(
    react$1.Switch,
    {
      key: id,
      checked: field.value.includes(id),
      disabled,
      onChange: () => __async(void 0, null, function* () {
        const newValue = field.value.includes(id) ? field.value.filter((value) => value !== id) : [...field.value, id];
        helpers.setValue(newValue);
      }),
      className: classNames__default["default"](
        "inline-block mb-2 last:mr-0 mr-2 px-2 py-1 text-sm tracking-wider leading-none bg-gray-100 hover:bg-green-400 focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900",
        {
          "bg-gray-100 ring-green-400 ": !field.value.includes(id),
          "bg-green-400  ring-green-400 focus:bg-green-400": field.value.includes(id)
        }
      )
    },
    title2,
    field.value.includes(id) ? /* @__PURE__ */ React__default["default"].createElement("span", { className: "inline-block ml-2" }, "\xD7") : null
  ))));
};

const Pdf = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "48.011",
      height: "56",
      viewBox: "0 0 48.011 56"
    },
    /* @__PURE__ */ React__default["default"].createElement("g", { id: "pdf", transform: "translate(-8 -4)" }, /* @__PURE__ */ React__default["default"].createElement(
      "rect",
      {
        id: "Rechteck_101",
        "data-name": "Rechteck 101",
        width: "30",
        height: "16",
        transform: "translate(10 34)",
        fill: "#a2c4d5"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        id: "Pfad_362",
        "data-name": "Pfad 362",
        d: "M56,18.75a.37.37,0,0,0,0-.14,1,1,0,0,0-.21-.32l-14-14a1,1,0,0,0-.32-.21.37.37,0,0,0-.14,0A.69.69,0,0,0,41,4H13a1,1,0,0,0-1,1V32H9a1,1,0,0,0-1,1V51a1,1,0,0,0,1,1h3v7a1,1,0,0,0,1,1H55a1,1,0,0,0,1-1V19a.69.69,0,0,0,0-.25ZM42,7.41,52.59,18H42ZM10,34H40V50H10Zm4,24V52H41a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H14V6H40V19a1,1,0,0,0,1,1H54V58Z",
        fill: "#214f58"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        id: "Pfad_363",
        "data-name": "Pfad 363",
        d: "M52.59,18H42V7.41Z",
        fill: "#fff"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        id: "Pfad_364",
        "data-name": "Pfad 364",
        d: "M54,20V58H14V52H41a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H14V6H40V19a1,1,0,0,0,1,1Z",
        fill: "#fff"
      }
    ), /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        id: "Pfad_365",
        "data-name": "Pfad 365",
        d: "M15,46V38h2.66a2.8,2.8,0,0,1,1.9.58,2.42,2.42,0,0,1,.83,1.92A2.54,2.54,0,0,1,20,41.82a2.19,2.19,0,0,1-1,.88,2.67,2.67,0,0,1-1.15.23h-1.2V46Zm1.69-4.52h.94a1.14,1.14,0,0,0,.81-.28,1,1,0,0,0,.29-.76q0-.92-1.1-.92h-.94ZM21.95,46V38h3a3.18,3.18,0,0,1,2.08.68A4,4,0,0,1,28.5,42a4.48,4.48,0,0,1-.5,2.11,3.52,3.52,0,0,1-1.4,1.45,4.54,4.54,0,0,1-2.22.44Zm1.69-1.52h1.08a1.93,1.93,0,0,0,1.09-.29,2.53,2.53,0,0,0,1-2.26,2.4,2.4,0,0,0-.95-2.12,1.87,1.87,0,0,0-1.08-.29H23.64ZM30.24,46V38h4.58v1.52H31.93v1.63h2.65v1.52H31.93V46Z",
        fill: "#214f58"
      }
    ))
  );
};

const Play = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "54",
      height: "54",
      className,
      viewBox: "0 0 54 54"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "g",
      {
        id: "Gruppe_513",
        "data-name": "Gruppe 513",
        transform: "translate(-264 -1440.21)"
      },
      /* @__PURE__ */ React__default["default"].createElement(
        "circle",
        {
          id: "Ellipse_2",
          "data-name": "Ellipse 2",
          cx: "27",
          cy: "27",
          r: "27",
          transform: "translate(264 1440.21)",
          fill: "#fff",
          opacity: "0.5"
        }
      ),
      /* @__PURE__ */ React__default["default"].createElement(
        "path",
        {
          id: "Polygon_2",
          "data-name": "Polygon 2",
          d: "M10.5,0,21,19H0Z",
          transform: "translate(303 1456.21) rotate(90)",
          fill: "currentColor"
        }
      )
    )
  );
};

const Popover = ({ open, children }) => {
  return /* @__PURE__ */ React__default["default"].createElement(PopoverProvider, { isOpen: open }, children);
};

const VideoCookieConsent = () => {
  const t = i18n.useTranslations();
  const { videoConsent, setVideoConsent } = useCookieConsent();
  const showCookieSettings = () => {
    if (typeof Optanon !== "undefined" && !Optanon.IsAlertBoxClosedAndValid()) {
      Optanon.ToggleInfoDisplay();
    } else {
      setVideoConsent(true);
    }
  };
  if (!videoConsent && typeof Optanon !== "undefined" && Optanon.IsAlertBoxClosedAndValid()) {
    setVideoConsent(true);
  }
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, !videoConsent && /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        "absolute z-40 left-0 top-0 w-full h-full bg-blue-900 bg-opacity/95 cursor-pointer"
      ),
      onClick: showCookieSettings
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col items-center justify-center w-full h-full" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col items-center justify-center p-5 w-full h-full text-white" }, /* @__PURE__ */ React__default["default"].createElement("p", { className: classNames__default["default"]("mb-3 text-center sm:mb-16 sm:mt-4") }, t("cookie_consent.video.overlay_message")), /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: "leading-6 text-center inline-block w-full md:w-72 bg-orange-500 ring-orange-500 hover:text-orange-500 border-orange-500 mt-5 px-2 py-2 w-full text-gray-900 whitespace-nowrap text-sm font-bold hover:bg-white border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1",
        onClick: showCookieSettings
      },
      t("cookie_consent.button.text")
    )))
  ));
};

const RemoteVideo = ({ title, url }) => {
  return /* @__PURE__ */ React__default["default"].createElement("figure", { className: "my-5 w-full sm:my-10 lg:max-w-3xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "aspect-w-16 aspect-h-9" }, /* @__PURE__ */ React__default["default"].createElement(VideoCookieConsent, null), /* @__PURE__ */ React__default["default"].createElement(
    "iframe",
    {
      "data-chromatic": "ignore",
      title,
      src: url,
      allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    }
  )), title && /* @__PURE__ */ React__default["default"].createElement("figcaption", { className: "mt-2 text-blue-900 text-sm sm:mt-4" }, title));
};

const Search = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      className,
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      }
    )
  );
};

const Seo = ({
  countryCode,
  url,
  title,
  description,
  imageUrl,
  imageAlt,
  author,
  meta,
  localizations,
  og
}) => {
  const { locale } = i18n.useIntl();
  const t = i18n.useTranslations();
  const translatedSitename = t("meta.sitename");
  const translatedTitle = t("meta.title");
  const translatedTitleSuffix = t("meta.title_suffix");
  const metaTitle = title ? `${title} | ${translatedSitename} | ${translatedTitleSuffix}` : `${translatedTitle} | ${translatedSitename} | ${translatedTitleSuffix}`;
  const metaDescription = description || t("meta.description");
  return /* @__PURE__ */ React__default["default"].createElement(
    reactHelmet.Helmet,
    {
      htmlAttributes: {
        lang: locale
      },
      title: metaTitle,
      meta: [
        {
          name: "description",
          content: metaDescription
        },
        {
          property: "og:url",
          content: url
        },
        {
          property: "og:title",
          content: (og == null ? void 0 : og.title) || metaTitle
        },
        {
          property: "og:description",
          content: metaDescription
        },
        {
          property: "og:type",
          content: (og == null ? void 0 : og.type) || "website"
        },
        {
          property: "og:image",
          content: imageUrl
        },
        {
          property: "og:image:alt",
          content: imageAlt
        },
        {
          property: "og:site_name",
          content: translatedSitename
        },
        {
          property: "og:locale",
          content: locale + "_" + countryCode
        },
        {
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          name: "twitter:image",
          content: imageUrl
        },
        {
          name: "twitter:creator",
          content: author
        },
        {
          name: "twitter:title",
          content: metaTitle
        },
        {
          name: "twitter:description",
          content: metaDescription
        }
      ].concat(meta || []).filter(({ content }) => Boolean(content)),
      link: [{ rel: "canonical", href: url }].concat(
        (localizations == null ? void 0 : localizations.filter((item) => item.langcode !== locale).map((item) => ({
          rel: "alternate",
          hrefLang: item.langcode,
          href: item.url
        }))) || []
      )
    }
  );
};

const Twitter = ({ className }) => {
  return /* @__PURE__ */ React__default["default"].createElement(
    "svg",
    {
      viewBox: "0 0 21 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      className
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "path",
      {
        d: "M16.5387 0H19.7589L12.7238 8.04821L21 19H14.5198L9.44429 12.3578L3.63674 19H0.414686L7.93935 10.3915L0 0H6.64467L11.2325 6.07123L16.5387 0ZM15.4086 17.0708H17.1929L5.67513 1.8279H3.76037L15.4086 17.0708Z",
        fill: "currentColor"
      }
    )
  );
};

const CookiePreferencesButton = ({ label }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "button",
    {
      onClick: () => {
        Optanon.ToggleInfoDisplay();
      },
      className: "flex w-full md:w-auto leading-6 text-center bg-orange-500 ring-orange-500 hover:text-orange-500 border-orange-500 mt-5 px-2 py-2 text-gray-900 text-sm font-bold hover:bg-white border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "mr-2 w-6 h-6" }, /* @__PURE__ */ React__default["default"].createElement(
      "svg",
      {
        role: "presentation",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 128 160",
        xmlSpace: "preserve",
        style: { fill: "currentcolor" }
      },
      /* @__PURE__ */ React__default["default"].createElement("g", null, /* @__PURE__ */ React__default["default"].createElement("path", { d: "M64,16.2c-2.6,0-5.2,0.2-7.6,0.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.3,0.1-0.4,0.1   c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.2,0.4   c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3,0,0.4c0.1,0.5,0.1,1,0.1,1.5c0,5.9-4.4,10.9-10.1,11.8c0,0,0,0,0,0c0,0,0,0,0,0   c-0.1,0-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.2-0.2,0.4   c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.7,0.2,1.4,0.2,2.2   C42.5,45.6,36,52,28.1,52c-2.5,0-4.8-0.6-6.9-1.8c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0   c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.4,0.3   c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-1.1,4-1.6,8.1-1.6,12.2   c0,26.4,21.5,47.8,47.8,47.8s47.8-21.5,47.8-47.8C111.8,37.6,90.4,16.2,64,16.2z M64,107.1c-23.7,0-43.1-19.3-43.1-43.1   c0-2.8,0.3-5.6,0.8-8.3c2,0.7,4.2,1.1,6.4,1.1c10.6,0,19.1-8.6,19.1-19.1c0-0.2,0-0.5-0.1-0.7c6.9-2,11.9-8.4,12-15.7   c1.6-0.2,3.1-0.3,4.8-0.3c23.7,0,43.1,19.3,43.1,43.1C107.1,87.7,87.7,107.1,64,107.1z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M88.4,79.8c-4.6,0-4.6,7.2,0,7.2C93,87,93,79.8,88.4,79.8z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M67.5,91.3c-4.6,0-4.6,7.2,0,7.2C72.1,98.5,72.1,91.3,67.5,91.3z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M95,56.9c-4.6,0-4.6,7.2,0,7.2C99.6,64,99.6,56.9,95,56.9z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M44.6,84.7c-4.6,0-4.6,7.2,0,7.2C49.3,91.8,49.3,84.7,44.6,84.7z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M33.1,63.9c-4.6,0-4.6,7.2,0,7.2C37.7,71.1,37.7,63.9,33.1,63.9z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M83.4,36c-4.6,0-4.6,7.2,0,7.2C88.1,43.2,88.1,36,83.4,36z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M63.5,36.8c4.6,0,4.6-7.2,0-7.2C58.8,29.7,58.8,36.8,63.5,36.8z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M61.3,72.2c-4.6,0-4.6,7.2,0,7.2C65.9,79.4,65.9,72.2,61.3,72.2z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M75.6,56.8c-4.6,0-4.6,7.2,0,7.2C80.2,64,80.2,56.8,75.6,56.8z" }), /* @__PURE__ */ React__default["default"].createElement("path", { d: "M55.2,52.1c-4.6,0-4.6,7.2,0,7.2C59.8,59.3,59.8,52.1,55.2,52.1z" }))
    )),
    /* @__PURE__ */ React__default["default"].createElement("span", { className: "pr-1" }, label || t("cookie_consent.button.preferences_text"))
  );
};

var __defProp$f = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const Cover = ({
  topics,
  Title,
  Subtitle,
  Lead,
  date,
  className,
  figure,
  EventsProps,
  pageLayout = "DEFAULT"
}) => {
  const formatDate = i18n.useFormatDate();
  return /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]({
        "lg:flex lg:justify-between": pageLayout === "HEADER_WITH_BACKGROUND"
      })
    },
    /* @__PURE__ */ React__default["default"].createElement("header", { className: classNames__default["default"]("lg:max-w-3xl lg:mr-20", className) }, topics && Boolean(topics == null ? void 0 : topics.length) && /* @__PURE__ */ React__default["default"].createElement("div", { className: "mb-4 text-green-500 text-sm" }, topics.map(({ id, title, Link }, index) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, index > 0 && /* @__PURE__ */ React__default["default"].createElement("span", { className: "inline-block mx-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement(
      Link,
      {
        key: id,
        className: "inline-block border-b hover:border-green-500 focus:border-green-500 border-transparent focus:outline-none transition duration-300 focus-visible:ring-2 ring-green-500 ring-offset-2"
      },
      title
    )))), /* @__PURE__ */ React__default["default"].createElement(
      "h1",
      {
        className: classNames__default["default"](
          "mb-5 font-serif text-2xl sm:text-3xl md:text-4xl md:leading-tight",
          {
            "text-blue-900": pageLayout === "DEFAULT",
            "text-white": pageLayout === "HEADER_WITH_BACKGROUND"
          }
        )
      },
      /* @__PURE__ */ React__default["default"].createElement(Title, null)
    ), Subtitle && /* @__PURE__ */ React__default["default"].createElement(
      "h2",
      {
        className: classNames__default["default"](
          "mb-5 font-serif text-lg sm:text-xl md:text-2xl md:leading-tight",
          {
            "text-blue-900": pageLayout === "DEFAULT",
            "text-white": pageLayout === "HEADER_WITH_BACKGROUND"
          }
        )
      },
      /* @__PURE__ */ React__default["default"].createElement(Subtitle, null)
    ), Lead && /* @__PURE__ */ React__default["default"].createElement(
      "p",
      {
        className: classNames__default["default"]("text-base leading-relaxed sm:mb-6", {
          "text-gray-900 font-bold": pageLayout === "DEFAULT",
          "text-white font-light": pageLayout === "HEADER_WITH_BACKGROUND"
        })
      },
      /* @__PURE__ */ React__default["default"].createElement(Lead, null)
    ), date && /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-green-500" }, formatDate(new Date(date))), EventsProps ? /* @__PURE__ */ React__default["default"].createElement(Events, __spreadProps$7(__spreadValues$f({}, EventsProps), { className: "mt-10" })) : null, pageLayout === "DEFAULT" && figure ? /* @__PURE__ */ React__default["default"].createElement(Figure, __spreadValues$f({}, figure)) : null),
    pageLayout === "HEADER_WITH_BACKGROUND" && figure ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:pl-20 max-w-[15rem] lg:max-w-xs mt-10 lg:mt-0" }, /* @__PURE__ */ React__default["default"].createElement(Figure, __spreadValues$f({ type: "secondary" }, figure)))) : null
  ), pageLayout === "HEADER_WITH_BACKGROUND" ? /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "hidden lg:block bg-white lg:-mx-7 lg:px-7 lg:py-8 mt-7 -mb-0.5"
    }
  ) : null);
};

const Footer = ({ menu, tags }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("footer", { className: "p-5 text-white bg-blue-900 sm:p-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Logo, { className: "mb-8 sm:mb-0", monochrome: true }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col my-5 md:flex-row md:my-10 md:space-x-20" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col order-last space-y-4 md:order-first" }, /* @__PURE__ */ React__default["default"].createElement("h3", { className: "text-green-400 text-xs tracking-wider leading-none uppercase" }, t("footer.contact")), /* @__PURE__ */ React__default["default"].createElement("address", { className: "text-sm not-italic" }, /* @__PURE__ */ React__default["default"].createElement("span", { className: "font-bold" }, t("footer.company")), /* @__PURE__ */ React__default["default"].createElement("br", null), t("footer.address"), /* @__PURE__ */ React__default["default"].createElement("br", null), t("footer.city"), /* @__PURE__ */ React__default["default"].createElement("br", null), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      className: "hover:text-green-400 focus:text-green-400 underline focus:outline-none duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900",
      href: "tel:+41315603650"
    },
    t("footer.tel")
  ), /* @__PURE__ */ React__default["default"].createElement("br", null), /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      className: "hover:text-green-400 focus:text-green-400 underline focus:outline-none duration-300 focus-visible:ring-2 ring-green-400 ring-offset-2 ring-offset-blue-900",
      href: `mailto:${t("footer.email")}`
    },
    t("footer.email")
  )), /* @__PURE__ */ React__default["default"].createElement(SocialShare, null)), /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:max-w-3xl mb-5 md:mb-0" }, /* @__PURE__ */ React__default["default"].createElement("h3", { className: "mb-4 text-green-400 text-xs tracking-wider leading-none uppercase" }, t("footer.recommendations")), /* @__PURE__ */ React__default["default"].createElement(FooterTags, { tags }))), /* @__PURE__ */ React__default["default"].createElement("div", { className: "items-end justify-between lg:flex" }, /* @__PURE__ */ React__default["default"].createElement(FooterMenu, { items: menu }), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-white text-xs tracking-wider leading-none uppercase lg:mt-0" }, t("footer.copyright", { year: (/* @__PURE__ */ new Date()).getFullYear() })))));
};

const Knowledge = ({ KnowledgeLink }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    KnowledgeLink,
    {
      activeClassName: "header-link-active",
      className: "relative ring-orange-500 hover:text-orange-500 relative ml-2 block items-center text-center text-blue-900 focus:outline-none duration-300 focus-visible:ring-4 ring-offset-8 xl:inline-flex xl:py-7 xl:px-5 xl:bg-[#f9f9f5]"
    },
    /* @__PURE__ */ React__default["default"].createElement(Info, { className: "w-6 h-6 xl:mr-1.5 xl:w-4 xl:h-4" }),
    /* @__PURE__ */ React__default["default"].createElement("span", { className: "text-sm xl:text-base" }, " ", t("header.core-knowledge")),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:bg-orange-500 group-focus:bg-orange-500 absolute bottom-0 left-0 xl:w-full xl:h-4 xl:transform xl:translate-y-1/2 xl:duration-300" })
  );
};

const Header = ({
  FilterLink,
  KnowledgeLink,
  HomeLink,
  SearchLink,
  metaMenu,
  mainMenu,
  localizations
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("header", { className: "bg-white border-b-8 border-blue-900" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "relative flex flex-col pt-5 px-5 w-full h-full xl:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container z-10 flex grow-0 shrink-0 items-center justify-between mx-auto max-w-7xl xl:block" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center justify-between pb-4 xl:pb-0" }, /* @__PURE__ */ React__default["default"].createElement(HomeLink, { className: "ring-orange-500 logo hover:text-blue-500 focus:text-blue-500 text-blue-900 focus:outline-none transition duration-300 focus-visible:ring-4 ring-offset-8" }, /* @__PURE__ */ React__default["default"].createElement(Logo, null)), /* @__PURE__ */ React__default["default"].createElement("div", { className: "hidden items-center self-start xl:flex" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "xl:mr-20" }, /* @__PURE__ */ React__default["default"].createElement(MetaMenu, { items: metaMenu })), /* @__PURE__ */ React__default["default"].createElement(LanguageSwitcher, { localizations }))), /* @__PURE__ */ React__default["default"].createElement("div", { className: "hidden justify-between xl:flex" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex mt-5 xl:mt-[37px] space-x-5" }, /* @__PURE__ */ React__default["default"].createElement(
    HomeLink,
    {
      className: "group relative hover:text-blue-500 focus:text-blue-500 text-blue-900 focus:outline-none transition duration-300",
      activeClassName: "header-link-active"
    },
    /* @__PURE__ */ React__default["default"].createElement(Home, { className: "w-6 h-6" }),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:bg-orange-500 group-focus:bg-orange-500 absolute bottom-0 left-0 w-full h-4 transform translate-y-1/2 duration-300" })
  ), /* @__PURE__ */ React__default["default"].createElement(MainMenu, { items: mainMenu }), /* @__PURE__ */ React__default["default"].createElement(
    SearchLink,
    {
      className: "relative hover:text-blue-500 focus:text-blue-500 text-blue-900",
      activeClassName: "header-link-active"
    },
    /* @__PURE__ */ React__default["default"].createElement(Search, { className: "w-6 h-6" }),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "absolute bottom-0 left-0 w-full h-4 transform translate-y-1/2 duration-300" })
  )), /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(Filter, { FilterLink }), /* @__PURE__ */ React__default["default"].createElement(Knowledge, { KnowledgeLink }))), /* @__PURE__ */ React__default["default"].createElement(Popover, null, ({ isOpen, openPopover, closePopover }) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(
    BodyClassName__default["default"],
    {
      className: classNames__default["default"]({
        "max-h-screen overflow-hidden": isOpen
      })
    }
  ), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center mb-4 space-x-4 xl:hidden" }, /* @__PURE__ */ React__default["default"].createElement(Filter, { FilterLink }), /* @__PURE__ */ React__default["default"].createElement(
    "button",
    {
      className: "ring-orange-500 mb-0.5 hover:text-blue-500 focus:text-blue-500 text-blue-900 text-sm focus:outline-none cursor-pointer transition duration-300 focus-visible:ring-4 ring-offset-8",
      onClick: openPopover
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "pl-4 text-center border-l border-gray-100" }, /* @__PURE__ */ React__default["default"].createElement("span", { className: "sr-only" }, "Open menu"), /* @__PURE__ */ React__default["default"].createElement(HamburgerMenu, { className: "w-8 h-8", "aria-hidden": "true" }), t("header.menu"))
  )), /* @__PURE__ */ React__default["default"].createElement(
    react$1.Transition,
    {
      show: isOpen,
      as: React.Fragment,
      enter: "duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-300",
      leave: "duration-300",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "fixed z-10 inset-0 flex flex-1 flex-col py-5 bg-white overflow-y-auto xl:hidden xl:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex shrink-0 items-center justify-between pb-4 px-5 border-b-8 border-blue-900" }, /* @__PURE__ */ React__default["default"].createElement(HomeLink, { className: "logo hover:text-blue-500 focus:text-blue-500 text-blue-900 focus:outline-none transition duration-300" }, /* @__PURE__ */ React__default["default"].createElement(Logo, null)), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center space-x-4" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "xl:hidden" }, /* @__PURE__ */ React__default["default"].createElement(Filter, { FilterLink })), /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: "ring-orange-500 hover:text-blue-500 focus:text-blue-500 text-blue-900 text-sm focus:outline-none cursor-pointer transition duration-300 focus-visible:ring-4 ring-offset-8 xl:hidden",
        onClick: closePopover
      },
      /* @__PURE__ */ React__default["default"].createElement("div", { className: "pl-4 text-center border-l border-gray-100" }, /* @__PURE__ */ React__default["default"].createElement("span", { className: "sr-only" }, "Close menu"), /* @__PURE__ */ React__default["default"].createElement(Close, { className: "w-8 h-8", "aria-hidden": "true" }), "Menu")
    ))), /* @__PURE__ */ React__default["default"].createElement(
      HomeLink,
      {
        className: "ring-orange-500 flex mx-5 pb-4 pt-5 hover:text-blue-500 focus:text-blue-500 text-blue-900 border-b border-dashed border-gray-300 focus:outline-none duration-300 focus-visible:ring-2 ring-offset-2",
        activeClassName: "!text-blue-500"
      },
      t("header.home"),
      /* @__PURE__ */ React__default["default"].createElement(Home, { className: "ml-2 w-5 h-5" })
    ), /* @__PURE__ */ React__default["default"].createElement(MainMenu, { items: mainMenu }), /* @__PURE__ */ React__default["default"].createElement(
      SearchLink,
      {
        className: "flex mb-5 mx-5 hover:text-blue-500 focus:text-blue-500 text-blue-900",
        activeClassName: "!text-blue-500"
      },
      t("header.search"),
      /* @__PURE__ */ React__default["default"].createElement(Search, { className: "ml-2 w-5 h-5" })
    ), /* @__PURE__ */ React__default["default"].createElement(
      KnowledgeLink,
      {
        className: "flex py-4 px-5 hover:text-blue-500 focus:text-blue-500 text-blue-900 bg-[#f9f9f5]",
        activeClassName: "!text-blue-500"
      },
      /* @__PURE__ */ React__default["default"].createElement(Info, { className: "mr-2 mt-1 w-4 h-4" }),
      t("header.core-knowledge")
    ), /* @__PURE__ */ React__default["default"].createElement(MetaMenu, { items: metaMenu }), /* @__PURE__ */ React__default["default"].createElement(LanguageSwitcher, { localizations }))
  ))))));
};

const ContentHub = ({ useContentHubQuery }) => {
  const t = i18n.useTranslations();
  const { filters } = useContentHub();
  const { currentPage: page } = usePager();
  const { isLoading, items } = useContentHubQuery({
    page,
    filters: {
      topics: filters == null ? void 0 : filters.topics
    }
  });
  return /* @__PURE__ */ React__default["default"].createElement("section", null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "my-5 sm:my-10" }, isLoading ? /* @__PURE__ */ React__default["default"].createElement("p", { className: "w-full text-blue-500 text-base animate-pulse" }, t("hub.loading")) : /* @__PURE__ */ React__default["default"].createElement(ContentHubResults, { items }), /* @__PURE__ */ React__default["default"].createElement(Pager, null)));
};

const FocusContentHub = ({ useContentHubFocusQuery }) => {
  const t = i18n.useTranslations();
  const { filters } = useContentHub();
  const { isLoading, items } = useContentHubFocusQuery({
    filters: {
      topics: filters == null ? void 0 : filters.topics
    }
  });
  return /* @__PURE__ */ React__default["default"].createElement("section", null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "my-5 sm:my-10" }, isLoading ? /* @__PURE__ */ React__default["default"].createElement("p", { className: "w-full text-blue-500 text-base animate-pulse" }, t("hub.loading")) : /* @__PURE__ */ React__default["default"].createElement(ContentHubFocusResults, { items })));
};

const PreFooter = ({ NewsletterLink, MembershipLink }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "bg-blue-100 py-10 px-5 lg:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl lg:flex" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1 lg:pr-20" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:flex lg:items-end lg:justify-between" }, /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement("h3", { className: "uppercase font-medium text-sm lg:text-base" }, t("pre-footer.newsletter.label")), /* @__PURE__ */ React__default["default"].createElement(H2, { className: "mt-3" }, t("pre-footer.newsletter.title")), /* @__PURE__ */ React__default["default"].createElement(
    NewsletterLink,
    {
      className: "leading-6 text-center inline-block w-full md:w-72 bg-orange-500 ring-orange-500 hover:text-orange-500 border-orange-500 mt-5 px-2 py-2 w-full text-gray-900 whitespace-nowrap text-sm font-bold hover:bg-white border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1"
    },
    t("pre-footer.newsletter.button")
  )), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mb-5 lg:mb-0 lg:ml-20 hidden lg:block" }, /* @__PURE__ */ React__default["default"].createElement(Envelope, null)))), /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "flex-1 mt-10 pt-10 lg:pt-0 lg:mt-0 lg:pl-20 border-t lg:border-l lg:border-t-0 border-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement("h3", { className: "uppercase font-medium text-sm lg:text-base" }, t("pre-footer.membership.label")),
    /* @__PURE__ */ React__default["default"].createElement(H2, { className: "mt-3" }, t("pre-footer.membership.title")),
    /* @__PURE__ */ React__default["default"].createElement(
      MembershipLink,
      {
        className: "leading-6 text-center inline-block w-full md:w-72 bg-orange-500 ring-orange-500 hover:text-orange-500 border-orange-500 mt-5 px-2 py-2 w-full text-gray-900 whitespace-nowrap text-sm font-bold hover:bg-white border focus:outline-none cursor-pointer select-none uppercase transition duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1"
      },
      t("pre-footer.membership.button")
    )
  )));
};

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
const StandardLayout = ({
  header,
  footerMenu,
  footerTags,
  messages,
  seo,
  children,
  buildHtml: buildHtml2,
  preFooter
}) => {
  var _a;
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(Seo, __spreadValues$e({}, seo)), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col min-h-screen" }, /* @__PURE__ */ React__default["default"].createElement(Header, __spreadValues$e({}, header)), /* @__PURE__ */ React__default["default"].createElement("main", { className: "flex-1" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "status-messages container mx-auto max-w-7xl" }, (_a = useAppendStatusMessagesFromLocation(messages)) == null ? void 0 : _a.map(
    (message, index) => {
      const Html = buildHtml2(message);
      return /* @__PURE__ */ React__default["default"].createElement(Message, { key: index }, /* @__PURE__ */ React__default["default"].createElement(Html, null));
    }
  )), children), /* @__PURE__ */ React__default["default"].createElement(PreFooter, __spreadValues$e({}, preFooter)), /* @__PURE__ */ React__default["default"].createElement(Footer, { menu: footerMenu, tags: footerTags })));
};

var __defProp$d = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const BasicPage = ({
  children,
  cover,
  pageLayout = "DEFAULT",
  rightColumn
}) => {
  const rightColumnIsActive = !!(rightColumn == null ? void 0 : rightColumn.length);
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]({
        "bg-blue-900": pageLayout === "HEADER_WITH_BACKGROUND"
      })
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]("px-5 sm:px-10 pt-10 pb-10 lg:pb-0", {
          "lg:-mb-20": pageLayout === "HEADER_WITH_BACKGROUND"
        })
      },
      /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadProps$6(__spreadValues$d({}, cover), { pageLayout })))
    )
  ), /* @__PURE__ */ React__default["default"].createElement("div", { className: "pb-10 px-5 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("container mx-auto max-w-7xl", {
        "lg:flex lg:justify-between": rightColumnIsActive
      })
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        className: classNames__default["default"]({
          "lg:max-w-xl xl:max-w-3xl lg:mr-20": rightColumnIsActive
        })
      },
      children
    ),
    rightColumnIsActive ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1 lg:mt-10 text-lg" }, rightColumn && rightColumn.map(({ title, content }, i) => /* @__PURE__ */ React__default["default"].createElement(
      InfoBoxList,
      {
        key: i,
        type: "secondary",
        className: "mt-5 first:mt-0",
        title
      },
      content
    ))) : null
  )));
};

const CompanyPage = ({
  companyName,
  Image: Image2,
  addition,
  city,
  countryCode,
  zipCode,
  poBox,
  address,
  otherAddresses,
  contactEmail,
  websiteLinkUrl,
  websiteLinkTitle,
  description,
  member,
  branches
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(H1, null, companyName, " ", addition), /* @__PURE__ */ React__default["default"].createElement("p", { className: "mt-5 text-lg" }, description), Image2 ? /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "md:max-w-sm mt-10" }) : null, address ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t(`company.address`)), /* @__PURE__ */ React__default["default"].createElement("strong", null, companyName, " ", addition), /* @__PURE__ */ React__default["default"].createElement("div", null, address, " ", poBox ? /* @__PURE__ */ React__default["default"].createElement("span", null, ", ", poBox) : null, /* @__PURE__ */ React__default["default"].createElement("br", null), city, " ", zipCode, /* @__PURE__ */ React__default["default"].createElement("br", null), t(`country.name.${countryCode}`))) : null, otherAddresses ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t(`company.other-address`)), otherAddresses) : null, contactEmail || websiteLinkUrl && websiteLinkTitle ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10 p-5 bg-green-100" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t(`company.contacts`)), /* @__PURE__ */ React__default["default"].createElement("ul", null, contactEmail ? /* @__PURE__ */ React__default["default"].createElement("li", null, "E-mail:", " ", /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      className: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300",
      href: `mailto:${contactEmail}`
    },
    contactEmail
  )) : null, websiteLinkUrl && websiteLinkTitle ? /* @__PURE__ */ React__default["default"].createElement("li", null, t(`company.website`), ":", " ", /* @__PURE__ */ React__default["default"].createElement(
    "a",
    {
      className: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300",
      href: websiteLinkUrl,
      target: "_blank",
      rel: "noreferrer"
    },
    websiteLinkTitle
  )) : null)) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t(`company.additional-info`)), /* @__PURE__ */ React__default["default"].createElement("span", null, t(`company.member`), ": ", member ? t(`company.yes`) : t(`company.no`)), branches ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10" }, /* @__PURE__ */ React__default["default"].createElement("strong", null, t("company.branches")), /* @__PURE__ */ React__default["default"].createElement("ul", { className: "mt-2 list-custom pl-5" }, branches == null ? void 0 : branches.map(({ drupalId, title, children }) => {
    return /* @__PURE__ */ React__default["default"].createElement("li", { key: drupalId }, title, children ? /* @__PURE__ */ React__default["default"].createElement("ul", { className: "mt-2" }, children == null ? void 0 : children.map(({ drupalId: drupalId2, title: title2 }) => {
      return /* @__PURE__ */ React__default["default"].createElement("li", { key: drupalId2 }, title2);
    })) : null);
  }))) : null)));
};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
const FactSheetPage = ({ children, cover, tags }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$c({}, cover)), children, /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$c({ className: "mt-10 lg:max-w-3xl" }, tags))));

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
const MultimediaDossierPage = ({ children, cover, tags }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl minimal-content" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$b({}, cover)), children, /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$b({ className: "mt-10 lg:max-w-3xl" }, tags))));

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
const BulletinPage = ({ children, cover, tags }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$a({}, cover)), children, /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$a({ className: "mt-10 lg:max-w-3xl" }, tags))));

const FourZeroFourPage = () => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "h-96 flex flex-col items-center justify-center" }, /* @__PURE__ */ React__default["default"].createElement(
    "h1",
    {
      className: "text-center text-blue-900 font-serif text-7xl md:leading-tight"
    },
    t("404.headline")
  ), /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-center text-xl md:text-2xl mt10" }, t("404.text")))));
};

var __defProp$9 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
const isDateSupported = () => {
  if (typeof window === "undefined") {
    return true;
  }
  const input = document.createElement("input");
  const value = "a";
  input.setAttribute("type", "date");
  input.setAttribute("value", value);
  return input.value !== value;
};
const DateWidget = ({ name }) => {
  const [field, , helpers] = formik.useField(name);
  return isDateSupported() ? /* @__PURE__ */ React__default["default"].createElement(
    formik.Field,
    {
      type: "date",
      name,
      id: name,
      value: field.value,
      className: "block relative mt-1 w-full leading-8 border-gray-300 focus:outline-none transition duration-300 focus:ring-1 focus:ring-blue-900 focus:ring-offset-1 lg:w-72"
    }
  ) : /* @__PURE__ */ React__default["default"].createElement(
    DatePicker__default["default"],
    {
      className: "block mt-1 w-full leading-8 border-gray-300 focus:outline-none transition duration-300 focus:ring-1 focus:ring-blue-900 focus:ring-offset-1 lg:w-72",
      selected: field.value ? new Date(field.value) : new Date(Date.now() - 864e5),
      dateFormat: "dd.MM.yyyy",
      onChange: (date) => {
        helpers.setValue(date.toLocaleDateString("en-CA"));
      }
    }
  );
};
const MyTopicsForm = ({
  useForm,
  theme,
  category,
  region,
  setIsFormOpen,
  useResultPrediction
}) => {
  const Form2 = useForm();
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(Form2, { className: "p-5 md:p-10 bg-blue-100" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:max-w-7xl mx-auto" }, setIsFormOpen ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-right" }, /* @__PURE__ */ React__default["default"].createElement(
    "button",
    {
      className: "inline-block text-right",
      onClick: () => setIsFormOpen(false)
    },
    /* @__PURE__ */ React__default["default"].createElement(Close, { strokeWidth: 1, className: "w-12 h-12 text-gray-500" })
  )) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:flex" }, /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(
    "label",
    {
      className: "block text-blue-900 text-sm font-normal cursor-pointer uppercase"
    },
    t("my-topics.from"),
    /* @__PURE__ */ React__default["default"].createElement(DateWidget, { name: "from" })
  ), /* @__PURE__ */ React__default["default"].createElement(
    "label",
    {
      className: "block text-blue-900 text-sm font-normal cursor-pointer uppercase mt-7"
    },
    t("my-topics.to"),
    /* @__PURE__ */ React__default["default"].createElement(DateWidget, { name: "to" })
  )), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10 lg:mt-0 lg:ml-20" }, theme && theme.length ? /* @__PURE__ */ React__default["default"].createElement(
    MultipleSelectBadges,
    {
      name: "theme",
      items: theme,
      title: t("my-topics.theme")
    }
  ) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:flex" }, category && category.length ? /* @__PURE__ */ React__default["default"].createElement(
    MultipleSelectBadges,
    {
      className: "mt-10 lg:mr-10",
      name: "category",
      items: category,
      title: t("my-topics.category")
    }
  ) : null, region && region.length ? /* @__PURE__ */ React__default["default"].createElement(
    MultipleSelectBadges,
    {
      className: "mt-10 lg:ml-10",
      name: "region",
      items: region,
      title: t("my-topics.region")
    }
  ) : null))), /* @__PURE__ */ React__default["default"].createElement(
    MyTopicsButtons,
    {
      setIsFormOpen,
      useResultPrediction
    }
  )));
};
const MyTopicsButtons = ({
  setIsFormOpen,
  useResultPrediction
}) => {
  const t = i18n.useTranslations();
  const formik$1 = formik.useFormikContext();
  const prediction = useResultPrediction();
  const predictionTranslation = prediction === void 0 ? 0 : prediction;
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "flex flex-col-reverse lg:flex-row lg:justify-end mt-5 lg:mt-10"
    },
    /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: classNames__default["default"]({
          "leading-8 inline-block lg:ml-10 w-full lg:w-48 ring-orange-500mt-5 lg:mt-0 px-6 py-2 w-full text-gray-900 whitespace-nowrap text-base font-bold border focus:outline-none cursor-pointer select-none uppercase transition duration-300": true,
          "hover:text-orange-500 focus:ring hover:ring focus:ring-2 focus:ring-offset-4 hover:ring-1 ring-offset-1": true
        }),
        type: "reset",
        onClick: () => {
          formik$1.resetForm();
        }
      },
      t("my-topics.reset-form")
    ),
    /* @__PURE__ */ React__default["default"].createElement(
      "button",
      {
        className: classNames__default["default"](
          "ring-orange-500 inline-block mt-5 px-6 py-2 w-full text-gray-900 whitespace-nowrap text-base font-bold leading-8 border focus:outline-none cursor-pointer select-none uppercase focus:ring lg:ml-10 lg:mt-0 lg:w-auto",
          {
            "border-orange-500 bg-orange-500 hover:text-orange-500 hover:bg-white hover:ring hover:ring-1 focus:ring-2 ring-offset-1 focus:ring-offset-4 transition duration-300": (prediction || 0) > 0,
            "animate-pulse": prediction === void 0,
            "border-gray-500 bg-gray-300 cursor-not-allowed": prediction === 0
          }
        ),
        disabled: prediction === void 0 || prediction === 0,
        type: "submit",
        onClick: () => {
          formik$1.submitForm();
          setIsFormOpen(false);
        }
      },
      /* @__PURE__ */ React__default["default"].createElement(Search, { className: "h-5 w-5 inline-block mr-3 -mt-0.5" }),
      predictionTranslation > 0 ? t("my-topics.submit-form.result", {
        prediction: predictionTranslation
      }) : t("my-topics.submit-form.no-result", {
        prediction: predictionTranslation
      })
    )
  );
};
const MyTopicsResult = ({
  useMyTopicsSearch,
  usePagination
}) => {
  const itemsPerPage = 15;
  const { isFetching, data, status } = useMyTopicsSearch(itemsPerPage);
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("opacity-100 transition duration-500", {
        "opacity-25 grayscale animate-pulse": isFetching && status !== "loading"
      })
    },
    (data == null ? void 0 : data.items) && (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ React__default["default"].createElement(TeaserBox, { items: (data == null ? void 0 : data.items) || [] }) : /* @__PURE__ */ React__default["default"].createElement("p", null, " ", t("my-topics.no-results")),
    /* @__PURE__ */ React__default["default"].createElement(
      Pagination,
      __spreadProps$5(__spreadValues$9({}, usePagination()), {
        itemsCount: data == null ? void 0 : data.total,
        itemsPerPage
      })
    )
  );
};
const MyTopics = ({
  useForm,
  theme,
  category,
  region,
  useMyTopicsSearch,
  usePagination,
  isFormOpen,
  setIsFormOpen,
  useResultPrediction
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, isFormOpen ? /* @__PURE__ */ React__default["default"].createElement(
    MyTopicsForm,
    {
      useResultPrediction,
      useForm,
      theme,
      category,
      region,
      setIsFormOpen,
      useMyTopicsSearch
    }
  ) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10 relative before:md:content-[''] before:md:block before:md:bg-blue-900 before:md:w-full before:md:h-10 before:md:absolute before:md:top-0 before:md:left-0" }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "relative md:bg-white md:pt-10 md:-top-10 mx-auto md:max-w-[85rem] md:px-10"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(
      MyTopicsResult,
      {
        useMyTopicsSearch,
        usePagination
      }
    ))
  )));
};

var __defProp$8 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
const MyTopicsPage = (props) => {
  const [localStorage] = props.useFilterContext();
  const [isFormOpen, setIsFormOpen] = React.useState(false);
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, props.heading && !isFormOpen ? /* @__PURE__ */ React__default["default"].createElement(
    Heading,
    __spreadProps$4(__spreadValues$8({}, props.heading), {
      setIsFormOpen,
      isFormOpen,
      localStorage
    })
  ) : null, /* @__PURE__ */ React__default["default"].createElement(
    MyTopics,
    __spreadProps$4(__spreadValues$8({}, props.MyTopics), {
      setIsFormOpen,
      isFormOpen
    })
  ));
};

var __defProp$7 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
const NewsPage = ({
  children,
  cover,
  tags,
  ReferencesProps,
  RelatedArticlesProps,
  ContentSource,
  EventsProps
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](RelatedArticlesProps && "lg:flex") }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        RelatedArticlesProps && "lg:max-w-xl xl:max-w-3xl lg:mr-20",
        "minimal-content"
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$7({ EventsProps }, cover)),
    children,
    ContentSource ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10 lg:max-w-3xl" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t("ui.contentSourceLabel")), /* @__PURE__ */ React__default["default"].createElement(
      ContentSource,
      {
        classNames: {
          a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
        }
      }
    )) : null,
    ReferencesProps ? /* @__PURE__ */ React__default["default"].createElement(References, __spreadValues$7({ className: "mt-10" }, ReferencesProps)) : null,
    /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadProps$3(__spreadValues$7({}, tags), { className: "mt-10 lg:max-w-3xl" }))
  ), RelatedArticlesProps ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1 mt-10 lg:mt-19" }, /* @__PURE__ */ React__default["default"].createElement(RelatedArticles, __spreadValues$7({}, RelatedArticlesProps))) : null)));
};

var __defProp$6 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const ContextPage = ({
  children,
  cover,
  tags,
  ReferencesProps,
  RelatedArticlesProps,
  ContentSource,
  ContentAuthor,
  EventsProps
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](RelatedArticlesProps && "lg:flex") }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        RelatedArticlesProps && "lg:max-w-xl xl:max-w-3xl lg:mr-20",
        "minimal-content"
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$6({ EventsProps }, cover)),
    children,
    ContentAuthor ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10 lg:max-w-3xl" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t("ui.contentAuthorLabel")), /* @__PURE__ */ React__default["default"].createElement(
      ContentAuthor,
      {
        classNames: {
          a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
        }
      }
    )) : null,
    ContentSource ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10 lg:max-w-3xl" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-2" }, t("ui.contentSourceLabel")), /* @__PURE__ */ React__default["default"].createElement(
      ContentSource,
      {
        classNames: {
          a: "inline-block text-blue-900 focus:outline-none underline hover:text-blue-500 ring-orange-500 focus-visible:ring-2 ring-offset-2 duration-300"
        }
      }
    )) : null,
    ReferencesProps ? /* @__PURE__ */ React__default["default"].createElement(References, __spreadValues$6({ className: "mt-10" }, ReferencesProps)) : null,
    /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadProps$2(__spreadValues$6({}, tags), { className: "mt-10 lg:max-w-3xl" }))
  ), RelatedArticlesProps ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1 mt-10 lg:mt-19" }, /* @__PURE__ */ React__default["default"].createElement(RelatedArticles, __spreadValues$6({}, RelatedArticlesProps))) : null)));
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
const PodcastPage = ({ children, cover, tags }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$5({}, cover)), children, /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$5({ className: "mt-10 lg:max-w-3xl" }, tags))));

var __defProp$4 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const PressReleasePage = ({
  children,
  cover,
  tags,
  ReferencesProps,
  InfoBoxListProps,
  InfoBoxProps,
  AttachmentsProps
}) => {
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"](AttachmentsProps && "lg:flex") }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"](
        AttachmentsProps && "lg:max-w-xl xl:max-w-3xl lg:mr-20",
        "minimal-content"
      )
    },
    /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$4({}, cover)),
    children,
    ReferencesProps ? /* @__PURE__ */ React__default["default"].createElement(References, __spreadValues$4({ className: "mt-10" }, ReferencesProps)) : null,
    /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$4({ className: "mt-10 lg:max-w-3xl" }, tags)),
    InfoBoxListProps && InfoBoxProps ? /* @__PURE__ */ React__default["default"].createElement(InfoBoxList, __spreadProps$1(__spreadValues$4({}, InfoBoxListProps), { className: "mt-10" }), /* @__PURE__ */ React__default["default"].createElement(InfoBox, __spreadValues$4({}, InfoBoxProps))) : null
  ), AttachmentsProps ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex-1 mt-10 lg:mt-19" }, /* @__PURE__ */ React__default["default"].createElement(Attachments, __spreadValues$4({}, AttachmentsProps))) : null)));
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const VideoPage = ({ children, cover, tags }) => /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues$3({}, cover)), children, /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$3({ className: "mt-10 lg:max-w-3xl" }, tags))));

const HeroContentItemTeaser = ({
  Headline,
  date,
  Link: Link2,
  typename
}) => {
  const typenameTranslation = useContentTypeTranslation(typename);
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "bg-blue-900 p-5 h-full" }, /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "text-white group" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:underline text-base" }, /* @__PURE__ */ React__default["default"].createElement(Headline, null)), /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm text-green-400 " }, date, /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, "\u2022"), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3" }, typenameTranslation))));
};
const HeroContentItem = ({
  Headline,
  Link: Link2,
  Image: Image2,
  video,
  typename
}) => {
  const [isOpen, setOpen] = React.useState(false);
  const videoData = video ? getVideoId__default["default"](video.embedUrl) : void 0;
  return video && videoData && videoData.id && (videoData.service === "youtube" || videoData.service === "vimeo") ? /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(
    ModalVideo__default["default"],
    {
      channel: videoData == null ? void 0 : videoData.service,
      onClose: () => setOpen(false),
      isOpen,
      videoId: videoData == null ? void 0 : videoData.id
    }
  ), /* @__PURE__ */ React__default["default"].createElement("button", { onClick: () => setOpen(true), className: "block w-full group hover:ring-orange-500 focus:ring-orange-500 md:aspect-h-8 md:aspect-w-16 focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1" }, /* @__PURE__ */ React__default["default"].createElement(HeroContentItemContent, { Headline, Image: Image2, typename }))) : /* @__PURE__ */ React__default["default"].createElement(Link2, { className: "block w-full group hover:ring-orange-500 focus:ring-orange-500 md:aspect-h-8 md:aspect-w-16 focus:outline-none duration-300 focus:ring hover:ring focus:ring-1 hover:ring-1 ring-offset-1" }, /* @__PURE__ */ React__default["default"].createElement(HeroContentItemContent, { Headline, Image: Image2, typename }));
};
const HeroContentItemContent = ({
  Headline,
  Image: Image2,
  typename
}) => {
  const typenameTranslation = useContentTypeTranslation(typename);
  return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, Image2 ? /* @__PURE__ */ React__default["default"].createElement(Image2, { className: "w-full block" }) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "hidden md:block absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" }), /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "md:absolute md:bottom-5 md:left-1/2 w-auto h-auto md:-translate-x-1/2 md:text-center bg-blue-900 p-5 md:bg-transparent text-white" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "text-sm" }, typenameTranslation), /* @__PURE__ */ React__default["default"].createElement("div", { className: "font-serif text-2xl md:text-3xl mt-3" }, /* @__PURE__ */ React__default["default"].createElement(Headline, null)))));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const HeroContent = ({ items, className }) => {
  const slicedItems = items.slice(1, items.length);
  return /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "xl:bg-blue-900 xl:h-16 w-full flex flex-col justify-end items-center mt-10 xl:mt-0"
    },
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "container container max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "bg-white xl:-mx-7 xl:px-7 xl:h-10" }))
  ), /* @__PURE__ */ React__default["default"].createElement("div", { className: classNames__default["default"]("px-5 pb-10 sm:px-10", className) }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(HeroContentItem, __spreadValues$2({}, items[0])), /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex flex-col mt-5 md:flex-row gap-1 md:gap-0.5" }, slicedItems.map((item, index) => {
    return /* @__PURE__ */ React__default["default"].createElement(
      "div",
      {
        key: index,
        className: classNames__default["default"](
          "w-full",
          { "md:w-1/3": slicedItems.length === 3 },
          { "md:w-1/2": slicedItems.length === 2 }
        )
      },
      /* @__PURE__ */ React__default["default"].createElement(HeroContentItemTeaser, __spreadValues$2({}, item))
    );
  })))));
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TopicPage = ({
  tags,
  layout,
  TeaserBoxProps,
  HeroContentProps,
  loading,
  error,
  currentPage,
  itemsPerPage,
  totalItems,
  changePage,
  ContentHubFocusResultsProps,
  heading,
  ignoreSticky,
  ContentPrefix
}) => {
  const teaserList = [...TeaserBoxProps.items];
  const heroContent = HeroContentProps && [...HeroContentProps.items] || [];
  const MainTeaserProps = currentPage === 1 && !ignoreSticky ? teaserList.shift() : void 0;
  return /* @__PURE__ */ React__default["default"].createElement(StandardLayout, __spreadValues$1({}, layout), heading ? /* @__PURE__ */ React__default["default"].createElement(Heading, __spreadValues$1({}, heading)) : null, heroContent.length > 0 ? /* @__PURE__ */ React__default["default"].createElement(HeroContent, { items: heroContent }) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, ContentPrefix ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "block mb-10" }, /* @__PURE__ */ React__default["default"].createElement(ContentPrefix, null)) : null, currentPage === 1 && (MainTeaserProps || ContentHubFocusResultsProps.items.length > 0) ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "block lg:flex mb-6" }, MainTeaserProps ? /* @__PURE__ */ React__default["default"].createElement(
    MainTeaser,
    __spreadValues$1({
      className: "lg:w-2/3 lg:pr-2"
    }, MainTeaserProps)
  ) : null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "lg:w-1/3 lg:pl-4 mt-6 lg:mt-0" }, /* @__PURE__ */ React__default["default"].createElement(ContentHubFocusResults, __spreadValues$1({}, ContentHubFocusResultsProps)))) : null, !loading && !error ? /* @__PURE__ */ React__default["default"].createElement(TeaserBox, __spreadProps(__spreadValues$1({}, TeaserBoxProps), { items: teaserList })) : null, loading ? /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-center italic" }, "Loading ...") : null, error ? /* @__PURE__ */ React__default["default"].createElement("p", { className: "text-center text-red-500 italic" }, "An error happened. We are very sorry.") : null, /* @__PURE__ */ React__default["default"].createElement(
    PagerProvider,
    {
      itemsCount: totalItems,
      currentPage,
      itemsPerPage,
      setCurrentPage: changePage
    },
    /* @__PURE__ */ React__default["default"].createElement(ContentHubTags, __spreadValues$1({ className: "mt-10" }, tags)),
    /* @__PURE__ */ React__default["default"].createElement(Pager, null)
  ))));
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const TopicCollectionPage = ({
  children,
  cover,
  TeaserBoxProps
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(Cover, __spreadValues({}, cover)), children, TeaserBoxProps.items.length ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-10" }, /* @__PURE__ */ React__default["default"].createElement("h2", { className: "font-bold text-blue-900 md:text-xl mb-5" }, t("ui.contentRelatedArticlesLabel")), /* @__PURE__ */ React__default["default"].createElement(TeaserBox, __spreadValues({}, TeaserBoxProps))) : null));
};

const RefinementList = reactInstantsearchDom.connectRefinementList(({ items, refine }) => /* @__PURE__ */ React__default["default"].createElement("ul", null, items.map((item) => {
  const itemId = reactFrameworkBridge.slugify(item.label);
  return /* @__PURE__ */ React__default["default"].createElement("li", { className: "pb-2", key: itemId }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "relative flex items-start" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex items-center h-5" }, /* @__PURE__ */ React__default["default"].createElement(
    "input",
    {
      id: itemId,
      name: itemId,
      type: "checkbox",
      className: "cursor-pointer focus:ring-green-400 h-4 w-4 text-orange-500 border-gray-300 ",
      checked: item.isRefined,
      onChange: () => {
        refine(item.value);
      }
    }
  )), /* @__PURE__ */ React__default["default"].createElement("div", { className: "ml-3 text-sm" }, /* @__PURE__ */ React__default["default"].createElement("label", { htmlFor: itemId, className: "text-gray-700  cursor-pointer" }, item.label, /* @__PURE__ */ React__default["default"].createElement("span", { className: "text-gray-500" }, " (", item.count, ")")))));
})));
const FilterToggle = ({
  showFilters,
  setShowFilters
}) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("md:hidden pl-10 cursor-pointer shrink-0"),
      onClick: () => setShowFilters(!showFilters)
    },
    /* @__PURE__ */ React__default["default"].createElement(Filtrate, { className: "mb-1 mx-auto w-6 h-6 xl:mr-3 xl:w-4 xl:h-4" }),
    /* @__PURE__ */ React__default["default"].createElement("span", { className: "text-sm xl:text-base" }, t("search.filters.toggle-label")),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "group-hover:bg-orange-500 group-focus:bg-orange-500 absolute bottom-0 left-0 xl:w-full xl:h-4 xl:transform xl:translate-y-1/2 xl:duration-300" })
  );
};
const SearchFilters = () => {
  const [showFilters, setShowFilters] = React.useState(false);
  const t = i18n.useTranslations();
  const refinementLists = [
    { attribute: "type", heading: t("search.filters.type-heading") }
  ];
  return /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex justify-between" }, /* @__PURE__ */ React__default["default"].createElement(SearchInput, null), /* @__PURE__ */ React__default["default"].createElement(
    FilterToggle,
    {
      showFilters,
      setShowFilters
    }
  )), /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: classNames__default["default"]("md:block", {
        hidden: !showFilters
      })
    },
    /* @__PURE__ */ React__default["default"].createElement("h3", { className: "font-bold uppercase pt-5 pb-2" }, t("search.filters-heading")),
    refinementLists.map((refinementList) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, { key: refinementList.attribute }, /* @__PURE__ */ React__default["default"].createElement("h4", { className: "text-sm font-medium pb-2 border-b mb-3" }, refinementList.heading), /* @__PURE__ */ React__default["default"].createElement(RefinementList, { attribute: refinementList.attribute }), /* @__PURE__ */ React__default["default"].createElement(ResetButton, { clearsQuery: true })))
  ));
};
const ResetButton = reactInstantsearchDom.connectCurrentRefinements(({ items, refine }) => {
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-7 " }, /* @__PURE__ */ React__default["default"].createElement(
    "button",
    {
      onClick: () => refine(items),
      disabled: !items.length,
      className: "leading-8 inline-block w-full ring-orange-500 lg:mt-0 px-4 lg:px-6 py-2 w-full text-gray-900 text-base font-bold border focus:outline-none cursor-pointer select-none uppercase transition duration-300 hover:text-orange-500 focus:ring hover:ring focus:ring-2 focus:ring-offset-4 hover:ring-1 ring-offset-1"
    },
    t("search.reset-button-label")
  ));
});

const useAlgoliaIndexName = () => {
  const langcode = i18n.useLocale();
  return langcode === "de" ? process.env.GATSBY_ALGOLIA_DE_INDEX_NAME || "dev_pages_de" : process.env.GATSBY_ALGOLIA_FR_INDEX_NAME || "dev_pages_fr";
};

const CustomHighlight = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: "_highlightResult",
    attribute,
    hit
  });
  return /* @__PURE__ */ React__default["default"].createElement("span", null, parsedHit.map(
    (part, index) => part.isHighlighted ? /* @__PURE__ */ React__default["default"].createElement("span", { key: index, className: "pb-0.5 border-orange-500 border-b" }, part.value) : /* @__PURE__ */ React__default["default"].createElement("span", { key: index }, part.value)
  ));
};
const SearchHighlight = reactInstantsearchDom.connectHighlight(CustomHighlight);

const CustomSnippet = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: "_snippetResult",
    attribute,
    hit
  });
  return /* @__PURE__ */ React__default["default"].createElement("span", null, parsedHit.map(
    (part, index) => part.isHighlighted ? /* @__PURE__ */ React__default["default"].createElement("span", { key: index, className: "pb-0.5 border-orange-500 border-b" }, part.value) : /* @__PURE__ */ React__default["default"].createElement("span", { key: index }, part.value)
  ));
};
const SearchSnippet = reactInstantsearchDom.connectHighlight(CustomSnippet);

const SearchResultHeader = reactInstantsearchDom.connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;
  const t = i18n.useTranslations();
  const indexName = useAlgoliaIndexName();
  return hitCount > 0 ? /* @__PURE__ */ React__default["default"].createElement("div", { className: "flex justify-between items-center mb-7" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "HitCount" }, hitCount, " ", t("search.result-label"), hitCount !== 1 ? t("search.result-label-suffix") : ``), /* @__PURE__ */ React__default["default"].createElement(
    SearchSort,
    {
      defaultRefinement: indexName,
      items: [
        { value: indexName, label: t("search.sort.most-relevant-label") },
        {
          value: `${indexName}_date`,
          label: t("search.sort.most-recent-label")
        }
      ]
    }
  )) : /* @__PURE__ */ React__default["default"].createElement("div", { className: "h-50px flex items-center" }, /* @__PURE__ */ React__default["default"].createElement("p", null, t("search.no-results")));
});
const PageHit = ({ hit }) => {
  const formatDate = i18n.useFormatDate();
  return /* @__PURE__ */ React__default["default"].createElement("a", { href: hit.path }, /* @__PURE__ */ React__default["default"].createElement(
    "div",
    {
      className: "page-hit mb-6 p-5 text-grey-900 bg-blue-100 border-b border-blue-900"
    },
    /* @__PURE__ */ React__default["default"].createElement("h4", { className: "font-serif text-blue-900" }, /* @__PURE__ */ React__default["default"].createElement(SearchHighlight, { attribute: "title", hit })),
    hit.content && /* @__PURE__ */ React__default["default"].createElement("p", { className: "mt-5" }, "...", /* @__PURE__ */ React__default["default"].createElement(SearchSnippet, { attribute: "content", hit }), "..."),
    /* @__PURE__ */ React__default["default"].createElement("div", { className: "mt-5 text-sm text-green-500" }, hit.publishedDate && /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, formatDate(new Date(hit.publishedDate)), /* @__PURE__ */ React__default["default"].createElement("span", { className: "ml-3 mr-3" }, "\u2022")), /* @__PURE__ */ React__default["default"].createElement("span", null, " ", hit.type))
  ));
};
const HitsInIndex = ({ index }) => {
  return /* @__PURE__ */ React__default["default"].createElement(reactInstantsearchDom.Index, { indexName: index.name }, /* @__PURE__ */ React__default["default"].createElement(SearchResultHeader, null), /* @__PURE__ */ React__default["default"].createElement(reactInstantsearchDom.Hits, { hitComponent: PageHit }));
};
const SearchResult = ({ indices }) => /* @__PURE__ */ React__default["default"].createElement("div", null, indices.map((index) => /* @__PURE__ */ React__default["default"].createElement(HitsInIndex, { index, key: index.name })));

const SearchPage = ({ indexName }) => {
  const createURL = (state) => `?${qs__default["default"].stringify(state)}`;
  const searchStateToUrl = (searchState2) => searchState2 ? createURL(searchState2) : "";
  const DEBOUNCE_TIME = 400;
  const [searchState, setSearchState] = React.useState({});
  const debouncedSetStateRef = React.useRef(null);
  React.useEffect(() => {
    const urlToSearchState = ({ search }) => qs__default["default"].parse(search.slice(1));
    const windowLocation = typeof window !== "undefined" ? window.location : null;
    if (windowLocation) {
      setSearchState(urlToSearchState(windowLocation));
    }
  }, []);
  const onSearchStateChange = (updatedSearchState) => {
    if (debouncedSetStateRef.current !== null) {
      clearTimeout(debouncedSetStateRef.current);
    }
    if (!updatedSearchState.page) {
      updatedSearchState.page = 1;
    }
    debouncedSetStateRef.current = setTimeout(() => {
      history.pushState("", "", searchStateToUrl(updatedSearchState));
    }, DEBOUNCE_TIME);
    setSearchState(updatedSearchState);
  };
  const searchClient = React.useMemo(
    () => algoliasearch__default["default"](
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY
    ),
    []
  );
  const searchIndices = [{ name: indexName, title: `Pages` }];
  const t = i18n.useTranslations();
  return /* @__PURE__ */ React__default["default"].createElement("div", { className: "px-5 py-10 sm:px-10" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "container mx-auto max-w-7xl" }, /* @__PURE__ */ React__default["default"].createElement(H1, { className: "mb-5" }, t("search.page-title")), /* @__PURE__ */ React__default["default"].createElement(
    reactInstantsearchDom.InstantSearch,
    {
      searchClient,
      searchState,
      indexName,
      onSearchStateChange
    },
    /* @__PURE__ */ React__default["default"].createElement(reactInstantsearchDom.ScrollTo, null, /* @__PURE__ */ React__default["default"].createElement("div", { className: "md:flex w-full" }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "w-full md:w-1/4 " }, /* @__PURE__ */ React__default["default"].createElement("div", { className: "mr-10 py-5 sticky top-0" }, /* @__PURE__ */ React__default["default"].createElement(SearchFilters, null))), searchState && /* @__PURE__ */ React__default["default"].createElement("div", { className: "w-full md:w-3/4 py-5" }, /* @__PURE__ */ React__default["default"].createElement(SearchResult, { indices: searchIndices }), /* @__PURE__ */ React__default["default"].createElement(
      reactInstantsearchDom.Pagination,
      {
        translations: {
          previous: "\u2039",
          next: "\u203A",
          first: "\xAB",
          last: "\xBB",
          page: (currentRefinement) => currentRefinement,
          ariaPrevious: t("pager.previous"),
          ariaNext: t("pager.next"),
          ariaFirst: t("pager.first-page"),
          ariaLast: t("pager.last-page"),
          ariaPage(currentRefinement) {
            return `${t(
              "pager.current-page"
            )} ${currentRefinement}`;
          }
        },
        showLast: true
      }
    ))))
  )));
};

exports.Attachments = Attachments;
exports.BasicPage = BasicPage;
exports.BlockMediaGallery = BlockMediaGallery;
exports.BlockTeaserItem = BlockTeaserItem;
exports.BlockTeaserList = BlockTeaserList;
exports.BulletinPage = BulletinPage;
exports.Calendar = Calendar;
exports.Clock = Clock;
exports.Close = Close;
exports.Company = Company;
exports.CompanyItem = CompanyItem;
exports.CompanyPage = CompanyPage;
exports.ContentHub = ContentHub;
exports.ContentHubFocusItem = ContentHubFocusItem;
exports.ContentHubFocusResults = ContentHubFocusResults;
exports.ContentHubItem = ContentHubItem;
exports.ContentHubProvider = ContentHubProvider;
exports.ContentHubResults = ContentHubResults;
exports.ContentHubTags = ContentHubTags;
exports.ContextPage = ContextPage;
exports.CookieConsentContext = CookieConsentContext;
exports.CookieConsentProvider = CookieConsentProvider;
exports.CookiePreferencesButton = CookiePreferencesButton;
exports.Cover = Cover;
exports.CustomSearchInput = CustomSearchInput;
exports.Document = Document;
exports.DocumentPlaceholder = DocumentPlaceholder;
exports.Download = Download;
exports.Envelope = Envelope;
exports.Events = Events;
exports.Facebook = Facebook;
exports.FactSheetPage = FactSheetPage;
exports.Figure = Figure;
exports.Filter = Filter;
exports.Filtrate = Filtrate;
exports.FocusContentHub = FocusContentHub;
exports.Footer = Footer;
exports.FooterMenu = FooterMenu;
exports.FooterTags = FooterTags;
exports.FourZeroFourPage = FourZeroFourPage;
exports.H1 = H1;
exports.H2 = H2;
exports.H3 = H3;
exports.H4 = H4;
exports.HamburgerMenu = HamburgerMenu;
exports.Header = Header;
exports.Heading = Heading;
exports.Home = Home;
exports.Info = Info;
exports.InfoBox = InfoBox;
exports.InfoBoxList = InfoBoxList;
exports.Instagram = Instagram;
exports.LanguageSwitcher = LanguageSwitcher;
exports.LinkList = LinkList;
exports.LinkedIn = LinkedIn;
exports.Logo = Logo;
exports.MainMenu = MainMenu;
exports.MainTeaser = MainTeaser;
exports.MapMarker = MapMarker;
exports.Message = Message;
exports.MetaMenu = MetaMenu;
exports.MultimediaDossierPage = MultimediaDossierPage;
exports.MultipleSelectBadges = MultipleSelectBadges;
exports.MyTopicsPage = MyTopicsPage;
exports.NewsPage = NewsPage;
exports.Offering = Offering;
exports.Pager = Pager;
exports.PagerProvider = PagerProvider;
exports.Pdf = Pdf;
exports.Play = Play;
exports.Podcast = Podcast;
exports.PodcastButtons = PodcastButtons;
exports.PodcastPage = PodcastPage;
exports.Popover = Popover;
exports.PopoverProvider = PopoverProvider;
exports.PreFooter = PreFooter;
exports.PressReleasePage = PressReleasePage;
exports.References = References;
exports.RelatedArticles = RelatedArticles;
exports.RemoteVideo = RemoteVideo;
exports.RichText = RichText;
exports.Search = Search;
exports.SearchInput = SearchInput;
exports.SearchPage = SearchPage;
exports.SearchSort = SearchSort;
exports.Seo = Seo;
exports.SocialShare = SocialShare;
exports.StandardLayout = StandardLayout;
exports.SubNavigation = SubNavigation;
exports.TeaserBox = TeaserBox;
exports.TeaserBoxItem = TeaserBoxItem;
exports.TopicCollectionPage = TopicCollectionPage;
exports.TopicPage = TopicPage;
exports.TopicTags = TopicTags;
exports.Twitter = Twitter;
exports.VideoPage = VideoPage;
exports.YouTube = YouTube;
exports.defaultApplyUrl = defaultApplyUrl;
exports.defaultSpotifyUrl = defaultSpotifyUrl;
exports.formatSize = formatSize;
exports.formatType = formatType;
exports.useAppendStatusMessagesFromLocation = useAppendStatusMessagesFromLocation;
exports.useContentHub = useContentHub;
exports.useContentTypeTranslation = useContentTypeTranslation;
exports.useCookieConsent = useCookieConsent;
exports.usePager = usePager;
exports.usePopover = usePopover;
